export interface Country {
  id: string
  identifiers: string[]
  name: string
  nationality: string
  alpha2: string
  alpha3: string
  iso3166: string
  region: string
  subRegion: string
  intermediateRegion: string
  intermediateRegionCode: string
  regionCode: string
  subRegionCode: string
  eeaMember: boolean
  economicArea: number
  countryCode: string
  language: string
}

export const countries: Country[] = [
  {
    id: '1bfe77eb-6896-47dc-8ecd-49d695d6bfe5',
    identifiers: ['Afghanistan', 'AF', 'AFG'],
    name: 'Afghanistan',
    nationality: 'Afghan',
    alpha2: 'AF',
    alpha3: 'AFG',
    iso3166: 'ISO 3166-2:AF',
    region: 'Asia',
    subRegion: 'Southern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '034',
    eeaMember: false,
    economicArea: 0,
    countryCode: '004',
    language: '',
  },
  {
    id: '88781707-d549-4999-9d68-8cf7778bc638',
    identifiers: ['Åland Islands', 'AX', 'ALA'],
    name: 'Åland Islands',
    nationality: 'Åland Islands',
    alpha2: 'AX',
    alpha3: 'ALA',
    iso3166: 'ISO 3166-2:AX',
    region: 'Europe',
    subRegion: 'Northern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '154',
    eeaMember: false,
    economicArea: 0,
    countryCode: '248',
    language: '',
  },
  {
    id: 'b9444546-687e-46af-b506-43b7a790f49a',
    identifiers: ['Albania', 'AL', 'ALB'],
    name: 'Albania',
    nationality: 'Albanian',
    alpha2: 'AL',
    alpha3: 'ALB',
    iso3166: 'ISO 3166-2:AL',
    region: 'Europe',
    subRegion: 'Southern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '039',
    eeaMember: false,
    economicArea: 0,
    countryCode: '008',
    language: '',
  },
  {
    id: '98dfe718-13d4-4245-b611-97dde37fa9fd',
    identifiers: ['Algeria', 'DZ', 'DZA'],
    name: 'Algeria',
    nationality: 'Algerian',
    alpha2: 'DZ',
    alpha3: 'DZA',
    iso3166: 'ISO 3166-2:DZ',
    region: 'Africa',
    subRegion: 'Northern Africa',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '002',
    subRegionCode: '015',
    eeaMember: false,
    economicArea: 0,
    countryCode: '012',
    language: '',
  },
  {
    id: '4f89e122-fd05-4547-8e83-e8a002f764d6',
    identifiers: ['American Samoa', 'AS', 'ASM'],
    name: 'American Samoa',
    nationality: 'American Samoa',
    alpha2: 'AS',
    alpha3: 'ASM',
    iso3166: 'ISO 3166-2:AS',
    region: 'Oceania',
    subRegion: 'Polynesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '061',
    eeaMember: false,
    economicArea: 0,
    countryCode: '016',
    language: '',
  },
  {
    id: '7bbd739a-a092-4b18-a375-6f328d0197e1',
    identifiers: ['Andorra', 'AD', 'AND'],
    name: 'Andorra',
    nationality: 'Andorra',
    alpha2: 'AD',
    alpha3: 'AND',
    iso3166: 'ISO 3166-2:AD',
    region: 'Europe',
    subRegion: 'Southern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '039',
    eeaMember: false,
    economicArea: 0,
    countryCode: '020',
    language: '',
  },
  {
    id: '261bb2b5-748a-45f6-9f69-05b813d5f1bd',
    identifiers: ['Angola', 'AO', 'AGO'],
    name: 'Angola',
    nationality: 'Angola',
    alpha2: 'AO',
    alpha3: 'AGO',
    iso3166: 'ISO 3166-2:AO',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Middle Africa',
    intermediateRegionCode: '017',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '024',
    language: '',
  },
  {
    id: 'b8cd3d2f-77a3-4213-926a-a9419adde323',
    identifiers: ['Anguilla', 'AI', 'AIA'],
    name: 'Anguilla',
    nationality: 'Anguilla',
    alpha2: 'AI',
    alpha3: 'AIA',
    iso3166: 'ISO 3166-2:AI',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '660',
    language: '',
  },
  {
    id: '7215fa0a-e7ed-4b1e-8290-bea4e31d261e',
    identifiers: ['Antarctica', 'AQ', 'ATA'],
    name: 'Antarctica',
    nationality: 'Antarctica',
    alpha2: 'AQ',
    alpha3: 'ATA',
    iso3166: 'ISO 3166-2:AQ',
    region: '',
    subRegion: '',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '',
    subRegionCode: '',
    eeaMember: false,
    economicArea: 0,
    countryCode: '010',
    language: '',
  },
  {
    id: 'b2b44465-c6fd-41d7-bc4b-ccb21aa14e61',
    identifiers: ['Antigua and Barbuda', 'AG', 'ATG'],
    name: 'Antigua and Barbuda',
    nationality: 'Antigua and Barbuda',
    alpha2: 'AG',
    alpha3: 'ATG',
    iso3166: 'ISO 3166-2:AG',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '028',
    language: '',
  },
  {
    id: '8bc80069-bc5a-44dd-ba6a-a8437a6b3ff1',
    identifiers: ['Argentina', 'AR', 'ARG'],
    name: 'Argentina',
    nationality: 'Argentina',
    alpha2: 'AR',
    alpha3: 'ARG',
    iso3166: 'ISO 3166-2:AR',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'South America',
    intermediateRegionCode: '005',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '032',
    language: '',
  },
  {
    id: '0098907b-fca4-4cb1-a9b9-29e9997eebd0',
    identifiers: ['Armenia', 'AM', 'ARM'],
    name: 'Armenia',
    nationality: 'Armenian',
    alpha2: 'AM',
    alpha3: 'ARM',
    iso3166: 'ISO 3166-2:AM',
    region: 'Asia',
    subRegion: 'Western Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '145',
    eeaMember: false,
    economicArea: 0,
    countryCode: '051',
    language: '',
  },
  {
    id: '7a85ccfc-c5ab-4d76-a95a-0fd404716f20',
    identifiers: ['Aruba', 'AW', 'ABW'],
    name: 'Aruba',
    nationality: 'Aruba',
    alpha2: 'AW',
    alpha3: 'ABW',
    iso3166: 'ISO 3166-2:AW',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '533',
    language: '',
  },
  {
    id: '9f412c5a-857b-4de3-962c-661e2dade16a',
    identifiers: ['Australia', 'AU', 'AUS'],
    name: 'Australia',
    nationality: 'Australian',
    alpha2: 'AU',
    alpha3: 'AUS',
    iso3166: 'ISO 3166-2:AU',
    region: 'Oceania',
    subRegion: 'Australia and New Zealand',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '053',
    eeaMember: false,
    economicArea: 3,
    countryCode: '036',
    language: '',
  },
  {
    id: '267e35e0-089e-40ef-9bfb-3031f09f0809',
    identifiers: ['Austria', 'AT', 'AUT'],
    name: 'Austria',
    nationality: 'Austrian',
    alpha2: 'AT',
    alpha3: 'AUT',
    iso3166: 'ISO 3166-2:AT',
    region: 'Europe',
    subRegion: 'Western Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '155',
    eeaMember: true,
    economicArea: 1,
    countryCode: '040',
    language: '',
  },
  {
    id: 'a22b3cc5-6c08-45b8-8f89-68bb6191cbed',
    identifiers: ['Azerbaijan', 'AZ', 'AZE'],
    name: 'Azerbaijan',
    nationality: 'Azerbaijan',
    alpha2: 'AZ',
    alpha3: 'AZE',
    iso3166: 'ISO 3166-2:AZ',
    region: 'Asia',
    subRegion: 'Western Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '145',
    eeaMember: false,
    economicArea: 0,
    countryCode: '031',
    language: '',
  },
  {
    id: 'cd5d642f-7125-42c9-a0bb-c698a23f7457',
    identifiers: ['Bahamas', 'BS', 'BHS'],
    name: 'Bahamas',
    nationality: 'Bahamas',
    alpha2: 'BS',
    alpha3: 'BHS',
    iso3166: 'ISO 3166-2:BS',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '044',
    language: '',
  },
  {
    id: '2014a04c-a79d-4cd7-9f3b-92f371cd63c1',
    identifiers: ['Bahrain', 'BH', 'BHR'],
    name: 'Bahrain',
    nationality: 'Bahrain',
    alpha2: 'BH',
    alpha3: 'BHR',
    iso3166: 'ISO 3166-2:BH',
    region: 'Asia',
    subRegion: 'Western Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '145',
    eeaMember: false,
    economicArea: 0,
    countryCode: '048',
    language: '',
  },
  {
    id: '56dc4a75-e569-4f64-9ed2-47747a4bcded',
    identifiers: ['Bangladesh', 'BD', 'BGD'],
    name: 'Bangladesh',
    nationality: 'Bangladeshi',
    alpha2: 'BD',
    alpha3: 'BGD',
    iso3166: 'ISO 3166-2:BD',
    region: 'Asia',
    subRegion: 'Southern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '034',
    eeaMember: false,
    economicArea: 0,
    countryCode: '050',
    language: '',
  },
  {
    id: '7fa02e29-9e0a-4490-aa43-6c1a10b774d9',
    identifiers: ['Barbados', 'BB', 'BRB'],
    name: 'Barbados',
    nationality: 'Barbados',
    alpha2: 'BB',
    alpha3: 'BRB',
    iso3166: 'ISO 3166-2:BB',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '052',
    language: '',
  },
  {
    id: '16084e19-e279-48cb-b159-33c71b91499c',
    identifiers: ['Belarus', 'BY', 'BLR'],
    name: 'Belarus',
    nationality: 'Belarus',
    alpha2: 'BY',
    alpha3: 'BLR',
    iso3166: 'ISO 3166-2:BY',
    region: 'Europe',
    subRegion: 'Eastern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '151',
    eeaMember: false,
    economicArea: 0,
    countryCode: '112',
    language: '',
  },
  {
    id: 'd9948722-ec05-4541-b030-709cd0573f41',
    identifiers: ['Belgium', 'BE', 'BEL'],
    name: 'Belgium',
    nationality: 'Belgian',
    alpha2: 'BE',
    alpha3: 'BEL',
    iso3166: 'ISO 3166-2:BE',
    region: 'Europe',
    subRegion: 'Western Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '155',
    eeaMember: true,
    economicArea: 1,
    countryCode: '056',
    language: '',
  },
  {
    id: 'fc3b7a70-ce6c-4b12-9bae-a1f8f7f979ea',
    identifiers: ['Belize', 'BZ', 'BLZ'],
    name: 'Belize',
    nationality: 'Belize',
    alpha2: 'BZ',
    alpha3: 'BLZ',
    iso3166: 'ISO 3166-2:BZ',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Central America',
    intermediateRegionCode: '013',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '084',
    language: '',
  },
  {
    id: 'd412b836-ce1f-46f9-8477-e0f759139a63',
    identifiers: ['Benin', 'BJ', 'BEN'],
    name: 'Benin',
    nationality: 'Benin',
    alpha2: 'BJ',
    alpha3: 'BEN',
    iso3166: 'ISO 3166-2:BJ',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Western Africa',
    intermediateRegionCode: '011',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '204',
    language: '',
  },
  {
    id: '9fdac1ab-c039-4841-8b18-faabc7afddc8',
    identifiers: ['Bermuda', 'BM', 'BMU'],
    name: 'Bermuda',
    nationality: 'Bermuda',
    alpha2: 'BM',
    alpha3: 'BMU',
    iso3166: 'ISO 3166-2:BM',
    region: 'Americas',
    subRegion: 'Northern America',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '019',
    subRegionCode: '021',
    eeaMember: false,
    economicArea: 0,
    countryCode: '060',
    language: '',
  },
  {
    id: '45ab9627-fffb-4bfe-a67a-3a686f166b26',
    identifiers: ['Bhutan', 'BT', 'BTN'],
    name: 'Bhutan',
    nationality: 'Bhutan',
    alpha2: 'BT',
    alpha3: 'BTN',
    iso3166: 'ISO 3166-2:BT',
    region: 'Asia',
    subRegion: 'Southern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '034',
    eeaMember: false,
    economicArea: 0,
    countryCode: '064',
    language: '',
  },
  {
    id: '2b73c80b-90e3-4db6-940a-3ab306db853d',
    identifiers: ['Bolivia (Plurinational State of)', 'BO', 'BOL'],
    name: 'Bolivia (Plurinational State of)',
    nationality: 'Bolivian',
    alpha2: 'BO',
    alpha3: 'BOL',
    iso3166: 'ISO 3166-2:BO',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'South America',
    intermediateRegionCode: '005',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '068',
    language: '',
  },
  {
    id: '6a9cbc0c-c462-44de-a67c-ecc56fba1f52',
    identifiers: ['Bonaire, Sint Eustatius and Saba', 'BQ', 'BES'],
    name: 'Bonaire, Sint Eustatius and Saba',
    nationality: 'Bonaire',
    alpha2: 'BQ',
    alpha3: 'BES',
    iso3166: 'ISO 3166-2:BQ',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '535',
    language: '',
  },
  {
    id: 'e381d0f4-d6c8-47db-8f66-6f42062bd632',
    identifiers: ['Bosnia and Herzegovina', 'BA', 'BIH'],
    name: 'Bosnia and Herzegovina',
    nationality: 'Bosnian',
    alpha2: 'BA',
    alpha3: 'BIH',
    iso3166: 'ISO 3166-2:BA',
    region: 'Europe',
    subRegion: 'Southern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '039',
    eeaMember: false,
    economicArea: 0,
    countryCode: '070',
    language: '',
  },
  {
    id: '43c1de60-1c10-4942-bf59-b1b2e4a7732c',
    identifiers: ['Botswana', 'BW', 'BWA'],
    name: 'Botswana',
    nationality: 'Batswana',
    alpha2: 'BW',
    alpha3: 'BWA',
    iso3166: 'ISO 3166-2:BW',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Southern Africa',
    intermediateRegionCode: '018',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '072',
    language: '',
  },
  {
    id: 'eb2735e1-f915-4601-9a48-1d72d43ffad5',
    identifiers: ['Bouvet Island', 'BV', 'BVT'],
    name: 'Bouvet Island',
    nationality: 'Bouvet Island',
    alpha2: 'BV',
    alpha3: 'BVT',
    iso3166: 'ISO 3166-2:BV',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'South America',
    intermediateRegionCode: '005',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '074',
    language: '',
  },
  {
    id: '6d044bed-daa4-4b93-b9c5-3ecbe5b64126',
    identifiers: ['Brazil', 'BR', 'BRA'],
    name: 'Brazil',
    nationality: 'Brazilian',
    alpha2: 'BR',
    alpha3: 'BRA',
    iso3166: 'ISO 3166-2:BR',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'South America',
    intermediateRegionCode: '005',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '076',
    language: 'Portugese',
  },
  {
    id: '60372e77-390d-4001-9569-58f354f9b38a',
    identifiers: ['British Indian Ocean Territory', 'IO', 'IOT'],
    name: 'British Indian Ocean Territory',
    nationality: 'British Indian Ocean Territory',
    alpha2: 'IO',
    alpha3: 'IOT',
    iso3166: 'ISO 3166-2:IO',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '086',
    language: '',
  },
  {
    id: '91099b72-9080-4a39-aa37-76440dd56dac',
    identifiers: ['Brunei Darussalam', 'BN', 'BRN'],
    name: 'Brunei Darussalam',
    nationality: 'Brunei Darussalam',
    alpha2: 'BN',
    alpha3: 'BRN',
    iso3166: 'ISO 3166-2:BN',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '035',
    eeaMember: false,
    economicArea: 0,
    countryCode: '096',
    language: '',
  },
  {
    id: 'a32d9a29-1868-46fd-bf9c-484c8b6b20ac',
    identifiers: ['Bulgaria', 'BG', 'BGR'],
    name: 'Bulgaria',
    nationality: 'Bulgarian',
    alpha2: 'BG',
    alpha3: 'BGR',
    iso3166: 'ISO 3166-2:BG',
    region: 'Europe',
    subRegion: 'Eastern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '151',
    eeaMember: true,
    economicArea: 1,
    countryCode: '100',
    language: '',
  },
  {
    id: 'b5d2c4cc-e3cb-4bd3-9208-26c2b25b962c',
    identifiers: ['Burkina Faso', 'BF', 'BFA'],
    name: 'Burkina Faso',
    nationality: 'Burkina Faso',
    alpha2: 'BF',
    alpha3: 'BFA',
    iso3166: 'ISO 3166-2:BF',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Western Africa',
    intermediateRegionCode: '011',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '854',
    language: '',
  },
  {
    id: '9e77db8c-8c9b-43fb-b211-2442ad41e55e',
    identifiers: ['Burundi', 'BI', 'BDI'],
    name: 'Burundi',
    nationality: 'Burundi',
    alpha2: 'BI',
    alpha3: 'BDI',
    iso3166: 'ISO 3166-2:BI',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '108',
    language: '',
  },
  {
    id: '769459a0-f8ea-4d4f-a1b3-d55b6ff76369',
    identifiers: ['Cabo Verde', 'CV', 'CPV'],
    name: 'Cabo Verde',
    nationality: 'Cabo Verde',
    alpha2: 'CV',
    alpha3: 'CPV',
    iso3166: 'ISO 3166-2:CV',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Western Africa',
    intermediateRegionCode: '011',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '132',
    language: '',
  },
  {
    id: '82e3b0fc-858e-455f-b72f-a6644eff8e9b',
    identifiers: ['Cambodia', 'KH', 'KHM'],
    name: 'Cambodia',
    nationality: 'Cambodian',
    alpha2: 'KH',
    alpha3: 'KHM',
    iso3166: 'ISO 3166-2:KH',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '035',
    eeaMember: false,
    economicArea: 0,
    countryCode: '116',
    language: '',
  },
  {
    id: '0d15c249-ae49-4083-9d2c-be069dad65d0',
    identifiers: ['Cameroon', 'CM', 'CMR'],
    name: 'Cameroon',
    nationality: 'Cameroonian',
    alpha2: 'CM',
    alpha3: 'CMR',
    iso3166: 'ISO 3166-2:CM',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Middle Africa',
    intermediateRegionCode: '017',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '120',
    language: '',
  },
  {
    id: '508181ea-b8b8-49a0-867f-8e17316cb526',
    identifiers: ['Canada', 'CA', 'CAN'],
    name: 'Canada',
    nationality: 'Canadian',
    alpha2: 'CA',
    alpha3: 'CAN',
    iso3166: 'ISO 3166-2:CA',
    region: 'Americas',
    subRegion: 'Northern America',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '019',
    subRegionCode: '021',
    eeaMember: false,
    economicArea: 3,
    countryCode: '124',
    language: '',
  },
  {
    id: '913ebea8-8af2-43df-a73e-5ba353dd4dce',
    identifiers: ['Cayman Islands', 'KY', 'CYM'],
    name: 'Cayman Islands',
    nationality: 'Cayman Islands',
    alpha2: 'KY',
    alpha3: 'CYM',
    iso3166: 'ISO 3166-2:KY',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '136',
    language: '',
  },
  {
    id: '36031acc-c129-40a0-9f06-c7cf6ad339ca',
    identifiers: ['Central African Republic', 'CF', 'CAF'],
    name: 'Central African Republic',
    nationality: 'Central African Republic',
    alpha2: 'CF',
    alpha3: 'CAF',
    iso3166: 'ISO 3166-2:CF',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Middle Africa',
    intermediateRegionCode: '017',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '140',
    language: '',
  },
  {
    id: '5225d484-75cc-46f5-b157-ef3c425c77cf',
    identifiers: ['Chad', 'TD', 'TCD'],
    name: 'Chad',
    nationality: 'Chad',
    alpha2: 'TD',
    alpha3: 'TCD',
    iso3166: 'ISO 3166-2:TD',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Middle Africa',
    intermediateRegionCode: '017',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '148',
    language: '',
  },
  {
    id: 'fc71f2cf-1f64-4d8e-8bcf-fa93fedee958',
    identifiers: ['Chile', 'CL', 'CHL'],
    name: 'Chile',
    nationality: 'Chilean',
    alpha2: 'CL',
    alpha3: 'CHL',
    iso3166: 'ISO 3166-2:CL',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'South America',
    intermediateRegionCode: '005',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '152',
    language: '',
  },
  {
    id: '1b87d45d-e8c5-4824-8c64-b4510699e81a',
    identifiers: ['China', 'CN', 'CHN'],
    name: 'China',
    nationality: 'Chinese',
    alpha2: 'CN',
    alpha3: 'CHN',
    iso3166: 'ISO 3166-2:CN',
    region: 'Asia',
    subRegion: 'Eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '030',
    eeaMember: false,
    economicArea: 0,
    countryCode: '156',
    language: '',
  },
  {
    id: '506ea4f0-1a5f-4891-a2b2-5552fbc5f102',
    identifiers: ['Christmas Island', 'CX', 'CXR'],
    name: 'Christmas Island',
    nationality: 'Christmas Island',
    alpha2: 'CX',
    alpha3: 'CXR',
    iso3166: 'ISO 3166-2:CX',
    region: 'Oceania',
    subRegion: 'Australia and New Zealand',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '053',
    eeaMember: false,
    economicArea: 0,
    countryCode: '162',
    language: '',
  },
  {
    id: 'e0bc73e3-ce61-4379-b085-fff996ef65eb',
    identifiers: ['Cocos (Keeling) Islands', 'CC', 'CCK'],
    name: 'Cocos (Keeling) Islands',
    nationality: 'Cocos (Keeling) Islands',
    alpha2: 'CC',
    alpha3: 'CCK',
    iso3166: 'ISO 3166-2:CC',
    region: 'Oceania',
    subRegion: 'Australia and New Zealand',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '053',
    eeaMember: false,
    economicArea: 0,
    countryCode: '166',
    language: '',
  },
  {
    id: '56510095-1b22-4a67-a644-ee618bc59e30',
    identifiers: ['Colombia', 'CO', 'COL'],
    name: 'Colombia',
    nationality: 'Colombian',
    alpha2: 'CO',
    alpha3: 'COL',
    iso3166: 'ISO 3166-2:CO',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'South America',
    intermediateRegionCode: '005',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '170',
    language: '',
  },
  {
    id: '4f203a83-fed1-4228-91fb-d9ec43afd63a',
    identifiers: ['Comoros', 'KM', 'COM'],
    name: 'Comoros',
    nationality: 'Comoros',
    alpha2: 'KM',
    alpha3: 'COM',
    iso3166: 'ISO 3166-2:KM',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '174',
    language: '',
  },
  {
    id: '1678f584-1b13-412b-be3e-879cc0b6faac',
    identifiers: ['Congo', 'CG', 'COG'],
    name: 'Congo',
    nationality: 'Congo',
    alpha2: 'CG',
    alpha3: 'COG',
    iso3166: 'ISO 3166-2:CG',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Middle Africa',
    intermediateRegionCode: '017',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '178',
    language: '',
  },
  {
    id: '364dbec0-4df5-4d8b-a104-2c3e5731c563',
    identifiers: ['Congo, Democratic Republic of the', 'CD', 'COD'],
    name: 'Congo, Democratic Republic of the',
    nationality: 'Congo',
    alpha2: 'CD',
    alpha3: 'COD',
    iso3166: 'ISO 3166-2:CD',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Middle Africa',
    intermediateRegionCode: '017',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '180',
    language: '',
  },
  {
    id: 'aaee701e-50c0-4594-bd85-ecfb16fa6cb4',
    identifiers: ['Cook Islands', 'CK', 'COK'],
    name: 'Cook Islands',
    nationality: 'Cook Islands',
    alpha2: 'CK',
    alpha3: 'COK',
    iso3166: 'ISO 3166-2:CK',
    region: 'Oceania',
    subRegion: 'Polynesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '061',
    eeaMember: false,
    economicArea: 0,
    countryCode: '184',
    language: '',
  },
  {
    id: '56a1d9e9-1bef-4d32-ad80-a66efe73d80b',
    identifiers: ['Costa Rica', 'CR', 'CRI'],
    name: 'Costa Rica',
    nationality: 'Costa Rican',
    alpha2: 'CR',
    alpha3: 'CRI',
    iso3166: 'ISO 3166-2:CR',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Central America',
    intermediateRegionCode: '013',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '188',
    language: '',
  },
  {
    id: 'f2f2dcb3-0f79-441f-ba0b-d05e3c5d62cb',
    identifiers: ["Côte d'Ivoire", 'CI', 'CIV'],
    name: "Côte d'Ivoire",
    nationality: "Côte d'Ivoire",
    alpha2: 'CI',
    alpha3: 'CIV',
    iso3166: 'ISO 3166-2:CI',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Western Africa',
    intermediateRegionCode: '011',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '384',
    language: '',
  },
  {
    id: 'a1516a3a-0688-4f82-b861-b71591e11bac',
    identifiers: ['Croatia', 'HR', 'HRV'],
    name: 'Croatia',
    nationality: 'Croatian',
    alpha2: 'HR',
    alpha3: 'HRV',
    iso3166: 'ISO 3166-2:HR',
    region: 'Europe',
    subRegion: 'Southern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '039',
    eeaMember: true,
    economicArea: 1,
    countryCode: '191',
    language: '',
  },
  {
    id: 'd1b673dc-f516-4447-91d7-f1a1b9e5fec1',
    identifiers: ['Cuba', 'CU', 'CUB'],
    name: 'Cuba',
    nationality: 'Cuban',
    alpha2: 'CU',
    alpha3: 'CUB',
    iso3166: 'ISO 3166-2:CU',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '192',
    language: '',
  },
  {
    id: '1341c685-29ad-411f-9886-a33f85a37c53',
    identifiers: ['Curaçao', 'CW', 'CUW'],
    name: 'Curaçao',
    nationality: 'Curaçao',
    alpha2: 'CW',
    alpha3: 'CUW',
    iso3166: 'ISO 3166-2:CW',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '531',
    language: '',
  },
  {
    id: '88669b63-d3dc-4496-8a37-0905d9bdd5d5',
    identifiers: ['Cyprus', 'CY', 'CYP'],
    name: 'Cyprus',
    nationality: 'Cypriot',
    alpha2: 'CY',
    alpha3: 'CYP',
    iso3166: 'ISO 3166-2:CY',
    region: 'Asia',
    subRegion: 'Western Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '145',
    eeaMember: true,
    economicArea: 1,
    countryCode: '196',
    language: '',
  },
  {
    id: 'de326bd2-12fd-4dd7-b907-27206120045a',
    identifiers: ['Czechia', 'CZ', 'CZE'],
    name: 'Czechia',
    nationality: 'Czech',
    alpha2: 'CZ',
    alpha3: 'CZE',
    iso3166: 'ISO 3166-2:CZ',
    region: 'Europe',
    subRegion: 'Eastern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '151',
    eeaMember: true,
    economicArea: 1,
    countryCode: '203',
    language: '',
  },
  {
    id: '1e374d8e-1e5b-4b15-a95b-a27c55827d22',
    identifiers: ['Denmark', 'DK', 'DNK'],
    name: 'Denmark',
    nationality: 'Danish',
    alpha2: 'DK',
    alpha3: 'DNK',
    iso3166: 'ISO 3166-2:DK',
    region: 'Europe',
    subRegion: 'Northern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '154',
    eeaMember: true,
    economicArea: 1,
    countryCode: '208',
    language: '',
  },
  {
    id: '2d53436b-6801-4b2c-8860-888bbb541234',
    identifiers: ['Djibouti', 'DJ', 'DJI'],
    name: 'Djibouti',
    nationality: 'Djibouti',
    alpha2: 'DJ',
    alpha3: 'DJI',
    iso3166: 'ISO 3166-2:DJ',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '262',
    language: '',
  },
  {
    id: 'cecafef3-a82d-411d-91b9-000f7dfc48ae',
    identifiers: ['Dominica', 'DM', 'DMA'],
    name: 'Dominica',
    nationality: 'Dominican',
    alpha2: 'DM',
    alpha3: 'DMA',
    iso3166: 'ISO 3166-2:DM',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '212',
    language: '',
  },
  {
    id: 'b7cb776a-6936-4651-b90d-7c07fcbae55e',
    identifiers: ['Dominican Republic', 'DO', 'DOM'],
    name: 'Dominican Republic',
    nationality: 'Dominican',
    alpha2: 'DO',
    alpha3: 'DOM',
    iso3166: 'ISO 3166-2:DO',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '214',
    language: '',
  },
  {
    id: 'cc650c2c-189f-414c-8756-400ca5dcd7e0',
    identifiers: ['Ecuador', 'EC', 'ECU'],
    name: 'Ecuador',
    nationality: 'Ecuadorian',
    alpha2: 'EC',
    alpha3: 'ECU',
    iso3166: 'ISO 3166-2:EC',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'South America',
    intermediateRegionCode: '005',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '218',
    language: '',
  },
  {
    id: '7d273754-a49c-4eba-84b8-9cebdc33688c',
    identifiers: ['Egypt', 'EG', 'EGY'],
    name: 'Egypt',
    nationality: 'Egyptian',
    alpha2: 'EG',
    alpha3: 'EGY',
    iso3166: 'ISO 3166-2:EG',
    region: 'Africa',
    subRegion: 'Northern Africa',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '002',
    subRegionCode: '015',
    eeaMember: false,
    economicArea: 0,
    countryCode: '818',
    language: '',
  },
  {
    id: '7f6de583-766a-4e22-98a8-8de93e06af33',
    identifiers: ['El Salvador', 'SV', 'SLV'],
    name: 'El Salvador',
    nationality: 'Salvadorian',
    alpha2: 'SV',
    alpha3: 'SLV',
    iso3166: 'ISO 3166-2:SV',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Central America',
    intermediateRegionCode: '013',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '222',
    language: '',
  },
  {
    id: '2acd5d4f-26b6-44e5-a7ce-99931a2c35de',
    identifiers: ['Equatorial Guinea', 'GQ', 'GNQ'],
    name: 'Equatorial Guinea',
    nationality: 'Equatorial Guinea',
    alpha2: 'GQ',
    alpha3: 'GNQ',
    iso3166: 'ISO 3166-2:GQ',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Middle Africa',
    intermediateRegionCode: '017',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '226',
    language: '',
  },
  {
    id: 'fcc43a90-38cd-4b47-8340-093748b4faae',
    identifiers: ['Eritrea', 'ER', 'ERI'],
    name: 'Eritrea',
    nationality: 'Eritrea',
    alpha2: 'ER',
    alpha3: 'ERI',
    iso3166: 'ISO 3166-2:ER',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '232',
    language: '',
  },
  {
    id: '3e7aa540-fdbd-4b37-89c3-86e1e934f830',
    identifiers: ['Estonia', 'EE', 'EST'],
    name: 'Estonia',
    nationality: 'Estonian',
    alpha2: 'EE',
    alpha3: 'EST',
    iso3166: 'ISO 3166-2:EE',
    region: 'Europe',
    subRegion: 'Northern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '154',
    eeaMember: true,
    economicArea: 1,
    countryCode: '233',
    language: '',
  },
  {
    id: '73a1d125-9b85-45af-a991-7a9e2e82d1f0',
    identifiers: ['Eswatini', 'SZ', 'SWZ'],
    name: 'Eswatini',
    nationality: 'Eswatini',
    alpha2: 'SZ',
    alpha3: 'SWZ',
    iso3166: 'ISO 3166-2:SZ',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Southern Africa',
    intermediateRegionCode: '018',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '748',
    language: '',
  },
  {
    id: '2e797817-5c23-4056-9048-063b2bc8b597',
    identifiers: ['Ethiopia', 'ET', 'ETH'],
    name: 'Ethiopia',
    nationality: 'Ethiopian',
    alpha2: 'ET',
    alpha3: 'ETH',
    iso3166: 'ISO 3166-2:ET',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '231',
    language: '',
  },
  {
    id: '61ad59e0-04b2-40fb-bd8d-3e32629a6304',
    identifiers: ['Falkland Islands (Malvinas)', 'FK', 'FLK'],
    name: 'Falkland Islands (Malvinas)',
    nationality: 'Falkland Islands',
    alpha2: 'FK',
    alpha3: 'FLK',
    iso3166: 'ISO 3166-2:FK',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'South America',
    intermediateRegionCode: '005',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '238',
    language: '',
  },
  {
    id: '2f00cf6c-a433-46ae-b653-5ac5ee9cac33',
    identifiers: ['Faroe Islands', 'FO', 'FRO'],
    name: 'Faroe Islands',
    nationality: 'Faroe Islands',
    alpha2: 'FO',
    alpha3: 'FRO',
    iso3166: 'ISO 3166-2:FO',
    region: 'Europe',
    subRegion: 'Northern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '154',
    eeaMember: false,
    economicArea: 0,
    countryCode: '234',
    language: '',
  },
  {
    id: '7a6e7d20-237d-4ea5-a42f-4d9c47f40487',
    identifiers: ['Fiji', 'FJ', 'FJI'],
    name: 'Fiji',
    nationality: 'Fijian',
    alpha2: 'FJ',
    alpha3: 'FJI',
    iso3166: 'ISO 3166-2:FJ',
    region: 'Oceania',
    subRegion: 'Melanesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '054',
    eeaMember: false,
    economicArea: 0,
    countryCode: '242',
    language: '',
  },
  {
    id: 'a004e9c8-3da5-48cc-9589-eef5f18b9e2a',
    identifiers: ['Finland', 'FI', 'FIN'],
    name: 'Finland',
    nationality: 'Finnish',
    alpha2: 'FI',
    alpha3: 'FIN',
    iso3166: 'ISO 3166-2:FI',
    region: 'Europe',
    subRegion: 'Northern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '154',
    eeaMember: true,
    economicArea: 1,
    countryCode: '246',
    language: '',
  },
  {
    id: '31dbea65-6bff-4cbb-8d08-d1e97b2e3427',
    identifiers: ['France', 'FR', 'FRA'],
    name: 'France',
    nationality: 'French',
    alpha2: 'FR',
    alpha3: 'FRA',
    iso3166: 'ISO 3166-2:FR',
    region: 'Europe',
    subRegion: 'Western Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '155',
    eeaMember: true,
    economicArea: 1,
    countryCode: '250',
    language: '',
  },
  {
    id: '85a12765-d0b4-4e83-8d60-ee11b0cefa17',
    identifiers: ['French Guiana', 'GF', 'GUF'],
    name: 'French Guiana',
    nationality: 'French Guiana',
    alpha2: 'GF',
    alpha3: 'GUF',
    iso3166: 'ISO 3166-2:GF',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'South America',
    intermediateRegionCode: '005',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '254',
    language: '',
  },
  {
    id: 'd8f3c173-2fa5-4b66-8380-f6875f9345ea',
    identifiers: ['French Polynesia', 'PF', 'PYF'],
    name: 'French Polynesia',
    nationality: 'French Polynesia',
    alpha2: 'PF',
    alpha3: 'PYF',
    iso3166: 'ISO 3166-2:PF',
    region: 'Oceania',
    subRegion: 'Polynesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '061',
    eeaMember: false,
    economicArea: 0,
    countryCode: '258',
    language: '',
  },
  {
    id: '68b6f22e-bb0f-4d5c-80a7-91b03ab9580a',
    identifiers: ['French Southern Territories', 'TF', 'ATF'],
    name: 'French Southern Territories',
    nationality: 'French Southern Territories',
    alpha2: 'TF',
    alpha3: 'ATF',
    iso3166: 'ISO 3166-2:TF',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '260',
    language: '',
  },
  {
    id: '5cfdd602-eb57-41d8-8c37-d2e567f09cd2',
    identifiers: ['Gabon', 'GA', 'GAB'],
    name: 'Gabon',
    nationality: 'Gabon',
    alpha2: 'GA',
    alpha3: 'GAB',
    iso3166: 'ISO 3166-2:GA',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Middle Africa',
    intermediateRegionCode: '017',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '266',
    language: '',
  },
  {
    id: '39041513-1c56-452f-b554-b18dbc450742',
    identifiers: ['Gambia', 'GM', 'GMB'],
    name: 'Gambia',
    nationality: 'Gambia',
    alpha2: 'GM',
    alpha3: 'GMB',
    iso3166: 'ISO 3166-2:GM',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Western Africa',
    intermediateRegionCode: '011',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '270',
    language: '',
  },
  {
    id: '86062b40-a366-4839-8497-65e7102a418c',
    identifiers: ['Georgia', 'GE', 'GEO'],
    name: 'Georgia',
    nationality: 'Georgian',
    alpha2: 'GE',
    alpha3: 'GEO',
    iso3166: 'ISO 3166-2:GE',
    region: 'Asia',
    subRegion: 'Western Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '145',
    eeaMember: false,
    economicArea: 0,
    countryCode: '268',
    language: '',
  },
  {
    id: '4efdf60a-f62e-4557-9b7f-4a2b8349557b',
    identifiers: ['Germany', 'DE', 'DEU', 'D'],
    name: 'Germany',
    nationality: 'German',
    alpha2: 'DE',
    alpha3: 'DEU',
    iso3166: 'ISO 3166-2:DE',
    region: 'Europe',
    subRegion: 'Western Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '155',
    eeaMember: true,
    economicArea: 1,
    countryCode: '276',
    language: 'German',
  },
  {
    id: 'a1776191-adae-4a4e-a201-15a7c81e01a6',
    identifiers: ['Ghana', 'GH', 'GHA'],
    name: 'Ghana',
    nationality: 'Ghanaian',
    alpha2: 'GH',
    alpha3: 'GHA',
    iso3166: 'ISO 3166-2:GH',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Western Africa',
    intermediateRegionCode: '011',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '288',
    language: '',
  },
  {
    id: 'f41bc5ba-ae03-4944-ac9d-01b4f9ebca94',
    identifiers: ['Gibraltar', 'GI', 'GIB'],
    name: 'Gibraltar',
    nationality: 'Gibraltar',
    alpha2: 'GI',
    alpha3: 'GIB',
    iso3166: 'ISO 3166-2:GI',
    region: 'Europe',
    subRegion: 'Southern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '039',
    eeaMember: false,
    economicArea: 0,
    countryCode: '292',
    language: '',
  },
  {
    id: '9a8e4cff-2c06-46e2-ad0f-4a70583559ab',
    identifiers: ['Greece', 'GR', 'GRC'],
    name: 'Greece',
    nationality: 'Greek',
    alpha2: 'GR',
    alpha3: 'GRC',
    iso3166: 'ISO 3166-2:GR',
    region: 'Europe',
    subRegion: 'Southern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '039',
    eeaMember: true,
    economicArea: 1,
    countryCode: '300',
    language: '',
  },
  {
    id: '00fec41f-f27d-4840-adf7-61178ec51b42',
    identifiers: ['Greenland', 'GL', 'GRL'],
    name: 'Greenland',
    nationality: 'Greenland',
    alpha2: 'GL',
    alpha3: 'GRL',
    iso3166: 'ISO 3166-2:GL',
    region: 'Americas',
    subRegion: 'Northern America',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '019',
    subRegionCode: '021',
    eeaMember: false,
    economicArea: 0,
    countryCode: '304',
    language: '',
  },
  {
    id: '7d014b43-51f5-480f-a8d3-b4963e5d00b1',
    identifiers: ['Grenada', 'GD', 'GRD'],
    name: 'Grenada',
    nationality: 'Grenada',
    alpha2: 'GD',
    alpha3: 'GRD',
    iso3166: 'ISO 3166-2:GD',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '308',
    language: '',
  },
  {
    id: 'ba9320f5-97b4-4900-9131-1ea45d96d18a',
    identifiers: ['Guadeloupe', 'GP', 'GLP'],
    name: 'Guadeloupe',
    nationality: 'Guadeloupe',
    alpha2: 'GP',
    alpha3: 'GLP',
    iso3166: 'ISO 3166-2:GP',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '312',
    language: '',
  },
  {
    id: '09a30fc8-b9ec-4f26-83a0-e02f6449bb6b',
    identifiers: ['Guam', 'GU', 'GUM'],
    name: 'Guam',
    nationality: 'Guam',
    alpha2: 'GU',
    alpha3: 'GUM',
    iso3166: 'ISO 3166-2:GU',
    region: 'Oceania',
    subRegion: 'Micronesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '057',
    eeaMember: false,
    economicArea: 0,
    countryCode: '316',
    language: '',
  },
  {
    id: '05b10e3b-307d-4b2f-9faf-710c10852f91',
    identifiers: ['Guatemala', 'GT', 'GTM'],
    name: 'Guatemala',
    nationality: 'Guatemala',
    alpha2: 'GT',
    alpha3: 'GTM',
    iso3166: 'ISO 3166-2:GT',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Central America',
    intermediateRegionCode: '013',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '320',
    language: '',
  },
  {
    id: '2f031771-9b41-457e-9dec-17081f01dc94',
    identifiers: ['Guernsey', 'GG', 'GGY'],
    name: 'Guernsey',
    nationality: 'Guernsey',
    alpha2: 'GG',
    alpha3: 'GGY',
    iso3166: 'ISO 3166-2:GG',
    region: 'Europe',
    subRegion: 'Northern Europe',
    intermediateRegion: 'Channel Islands',
    intermediateRegionCode: '830',
    regionCode: '150',
    subRegionCode: '154',
    eeaMember: false,
    economicArea: 0,
    countryCode: '831',
    language: '',
  },
  {
    id: '5dabaef2-8f90-40bc-916c-320a37daed77',
    identifiers: ['Guinea', 'GN', 'GIN'],
    name: 'Guinea',
    nationality: 'Guinea',
    alpha2: 'GN',
    alpha3: 'GIN',
    iso3166: 'ISO 3166-2:GN',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Western Africa',
    intermediateRegionCode: '011',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '324',
    language: '',
  },
  {
    id: '66e64cc1-afed-4aaf-9746-5e721d58a777',
    identifiers: ['Guinea-Bissau', 'GW', 'GNB'],
    name: 'Guinea-Bissau',
    nationality: 'Guinea-Bissau',
    alpha2: 'GW',
    alpha3: 'GNB',
    iso3166: 'ISO 3166-2:GW',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Western Africa',
    intermediateRegionCode: '011',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '624',
    language: '',
  },
  {
    id: '37162b47-6464-457d-8381-3aa1af825e45',
    identifiers: ['Guyana', 'GY', 'GUY'],
    name: 'Guyana',
    nationality: 'Guyana',
    alpha2: 'GY',
    alpha3: 'GUY',
    iso3166: 'ISO 3166-2:GY',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'South America',
    intermediateRegionCode: '005',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '328',
    language: '',
  },
  {
    id: 'b25cca9c-9933-4dd3-890d-ab244799420a',
    identifiers: ['Haiti', 'HT', 'HTI'],
    name: 'Haiti',
    nationality: 'Haitian',
    alpha2: 'HT',
    alpha3: 'HTI',
    iso3166: 'ISO 3166-2:HT',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '332',
    language: '',
  },
  {
    id: '9e487649-875c-4d71-855e-6cc5d687ca45',
    identifiers: ['Heard Island and McDonald Islands', 'HM', 'HMD'],
    name: 'Heard Island and McDonald Islands',
    nationality: 'Heard Island and McDonald Islands',
    alpha2: 'HM',
    alpha3: 'HMD',
    iso3166: 'ISO 3166-2:HM',
    region: 'Oceania',
    subRegion: 'Australia and New Zealand',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '053',
    eeaMember: false,
    economicArea: 0,
    countryCode: '334',
    language: '',
  },
  {
    id: 'a345a42a-1239-4b85-8612-95b13b1e8140',
    identifiers: ['Holy See', 'VA', 'VAT'],
    name: 'Holy See',
    nationality: 'Holy See',
    alpha2: 'VA',
    alpha3: 'VAT',
    iso3166: 'ISO 3166-2:VA',
    region: 'Europe',
    subRegion: 'Southern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '039',
    eeaMember: false,
    economicArea: 0,
    countryCode: '336',
    language: '',
  },
  {
    id: '5e027aa2-2e27-4a48-87cf-a472ba204ac7',
    identifiers: ['Honduras', 'HN', 'HND'],
    name: 'Honduras',
    nationality: 'Honduran',
    alpha2: 'HN',
    alpha3: 'HND',
    iso3166: 'ISO 3166-2:HN',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Central America',
    intermediateRegionCode: '013',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '340',
    language: '',
  },
  {
    id: '8e8cb75f-fa25-4622-a361-e888ab2fd435',
    identifiers: ['Hong Kong', 'HK', 'HKG', 'GBN'],
    name: 'Hong Kong',
    nationality: 'Hong Kong',
    alpha2: 'HK',
    alpha3: 'HKG',
    iso3166: 'ISO 3166-2:HK',
    region: 'Asia',
    subRegion: 'Eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '030',
    eeaMember: false,
    economicArea: 0,
    countryCode: '344',
    language: '',
  },
  {
    id: 'f668a69e-0e38-486d-b1eb-63588991591a',
    identifiers: ['Hungary', 'HU', 'HUN'],
    name: 'Hungary',
    nationality: 'Hungarian',
    alpha2: 'HU',
    alpha3: 'HUN',
    iso3166: 'ISO 3166-2:HU',
    region: 'Europe',
    subRegion: 'Eastern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '151',
    eeaMember: true,
    economicArea: 1,
    countryCode: '348',
    language: '',
  },
  {
    id: '364790a3-55f2-4926-8cfd-bf73b166038a',
    identifiers: ['Iceland', 'IS', 'ISL'],
    name: 'Iceland',
    nationality: 'Icelandic',
    alpha2: 'IS',
    alpha3: 'ISL',
    iso3166: 'ISO 3166-2:IS',
    region: 'Europe',
    subRegion: 'Northern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '154',
    eeaMember: true,
    economicArea: 1,
    countryCode: '352',
    language: '',
  },
  {
    id: 'ee992cb5-ccee-4def-b6e7-6d24ff587439',
    identifiers: ['India', 'IN', 'IND'],
    name: 'India',
    nationality: 'Indian',
    alpha2: 'IN',
    alpha3: 'IND',
    iso3166: 'ISO 3166-2:IN',
    region: 'Asia',
    subRegion: 'Southern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '034',
    eeaMember: false,
    economicArea: 0,
    countryCode: '356',
    language: '',
  },
  {
    id: '2f46fa55-838c-4bdf-b931-c8ea3e067aee',
    identifiers: ['Indonesia', 'ID', 'IDN'],
    name: 'Indonesia',
    nationality: 'Indonesian',
    alpha2: 'ID',
    alpha3: 'IDN',
    iso3166: 'ISO 3166-2:ID',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '035',
    eeaMember: false,
    economicArea: 0,
    countryCode: '360',
    language: '',
  },
  {
    id: 'c5df7530-e158-4e0d-9e38-b8b49dc80162',
    identifiers: ['Iran (Islamic Republic of)', 'IR', 'IRN'],
    name: 'Iran (Islamic Republic of)',
    nationality: 'Iranian',
    alpha2: 'IR',
    alpha3: 'IRN',
    iso3166: 'ISO 3166-2:IR',
    region: 'Asia',
    subRegion: 'Southern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '034',
    eeaMember: false,
    economicArea: 0,
    countryCode: '364',
    language: '',
  },
  {
    id: '1f92c7f7-e9fe-4403-9380-7aba40fb7377',
    identifiers: ['Iraq', 'IQ', 'IRQ'],
    name: 'Iraq',
    nationality: 'Iraqi',
    alpha2: 'IQ',
    alpha3: 'IRQ',
    iso3166: 'ISO 3166-2:IQ',
    region: 'Asia',
    subRegion: 'Western Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '145',
    eeaMember: false,
    economicArea: 0,
    countryCode: '368',
    language: '',
  },
  {
    id: 'bdd8660b-9ee0-4ab5-a39d-b29755e7d603',
    identifiers: ['Ireland', 'IE', 'IRL'],
    name: 'Ireland',
    nationality: 'Irish',
    alpha2: 'IE',
    alpha3: 'IRL',
    iso3166: 'ISO 3166-2:IE',
    region: 'Europe',
    subRegion: 'Northern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '154',
    eeaMember: true,
    economicArea: 1,
    countryCode: '372',
    language: '',
  },
  {
    id: '71738d5d-ab5b-4d2f-b903-c537cdad86bc',
    identifiers: ['Isle of Man', 'IM', 'IMN'],
    name: 'Isle of Man',
    nationality: 'Isle of Man',
    alpha2: 'IM',
    alpha3: 'IMN',
    iso3166: 'ISO 3166-2:IM',
    region: 'Europe',
    subRegion: 'Northern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '154',
    eeaMember: false,
    economicArea: 0,
    countryCode: '833',
    language: '',
  },
  {
    id: '0e4b8b6f-09a6-4661-ac9c-408ffb4948ff',
    identifiers: ['Israel', 'IL', 'ISR'],
    name: 'Israel',
    nationality: 'Israeli',
    alpha2: 'IL',
    alpha3: 'ISR',
    iso3166: 'ISO 3166-2:IL',
    region: 'Asia',
    subRegion: 'Western Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '145',
    eeaMember: false,
    economicArea: 0,
    countryCode: '376',
    language: '',
  },
  {
    id: '4da12476-45de-4710-a63a-3ebd44f83b0f',
    identifiers: ['Italy', 'IT', 'ITA'],
    name: 'Italy',
    nationality: 'Italian',
    alpha2: 'IT',
    alpha3: 'ITA',
    iso3166: 'ISO 3166-2:IT',
    region: 'Europe',
    subRegion: 'Southern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '039',
    eeaMember: true,
    economicArea: 1,
    countryCode: '380',
    language: '',
  },
  {
    id: 'f05b82d3-a015-43fb-a0bd-939c150870ec',
    identifiers: ['Jamaica', 'JM', 'JAM'],
    name: 'Jamaica',
    nationality: 'Jamaican',
    alpha2: 'JM',
    alpha3: 'JAM',
    iso3166: 'ISO 3166-2:JM',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '388',
    language: '',
  },
  {
    id: 'd44e5843-ee3c-412a-b8d8-e5ef1a694d36',
    identifiers: ['Japan', 'JP', 'JPN'],
    name: 'Japan',
    nationality: 'Japanese',
    alpha2: 'JP',
    alpha3: 'JPN',
    iso3166: 'ISO 3166-2:JP',
    region: 'Asia',
    subRegion: 'Eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '030',
    eeaMember: false,
    economicArea: 3,
    countryCode: '392',
    language: '',
  },
  {
    id: '8491e843-a092-43e5-bc1b-c99c353220d2',
    identifiers: ['Jersey', 'JE', 'JEY'],
    name: 'Jersey',
    nationality: 'Jersey',
    alpha2: 'JE',
    alpha3: 'JEY',
    iso3166: 'ISO 3166-2:JE',
    region: 'Europe',
    subRegion: 'Northern Europe',
    intermediateRegion: 'Channel Islands',
    intermediateRegionCode: '830',
    regionCode: '150',
    subRegionCode: '154',
    eeaMember: false,
    economicArea: 0,
    countryCode: '832',
    language: '',
  },
  {
    id: 'efafeb36-180e-4672-aacc-09e1b4d22859',
    identifiers: ['Jordan', 'JO', 'JOR'],
    name: 'Jordan',
    nationality: 'Jordan',
    alpha2: 'JO',
    alpha3: 'JOR',
    iso3166: 'ISO 3166-2:JO',
    region: 'Asia',
    subRegion: 'Western Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '145',
    eeaMember: false,
    economicArea: 0,
    countryCode: '400',
    language: '',
  },
  {
    id: 'cd6f9fed-b182-4d52-b50a-537872b5a625',
    identifiers: ['Kazakhstan', 'KZ', 'KAZ'],
    name: 'Kazakhstan',
    nationality: 'Kazakhstan',
    alpha2: 'KZ',
    alpha3: 'KAZ',
    iso3166: 'ISO 3166-2:KZ',
    region: 'Asia',
    subRegion: 'Central Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '143',
    eeaMember: false,
    economicArea: 0,
    countryCode: '398',
    language: '',
  },
  {
    id: 'b6201590-c93b-4b6d-88c1-027882655971',
    identifiers: ['Kenya', 'KE', 'KEN'],
    name: 'Kenya',
    nationality: 'Kenyan',
    alpha2: 'KE',
    alpha3: 'KEN',
    iso3166: 'ISO 3166-2:KE',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '404',
    language: '',
  },
  {
    id: 'f6ca3236-b3cc-47a7-bcd3-f6636f6fc0ec',
    identifiers: ['Kiribati', 'KI', 'KIR'],
    name: 'Kiribati',
    nationality: 'Kiribati',
    alpha2: 'KI',
    alpha3: 'KIR',
    iso3166: 'ISO 3166-2:KI',
    region: 'Oceania',
    subRegion: 'Micronesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '057',
    eeaMember: false,
    economicArea: 0,
    countryCode: '296',
    language: '',
  },
  {
    id: '0ebbbe68-1f4a-4cad-a8c3-ca544a96314e',
    identifiers: ["Korea (Democratic People's Republic of)", 'KP', 'PRK'],
    name: "Korea (Democratic People's Republic of)",
    nationality: 'Korean',
    alpha2: 'KP',
    alpha3: 'PRK',
    iso3166: 'ISO 3166-2:KP',
    region: 'Asia',
    subRegion: 'Eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '030',
    eeaMember: false,
    economicArea: 0,
    countryCode: '408',
    language: '',
  },
  {
    id: '232f31dc-9668-4766-8ad4-12eace88861b',
    identifiers: ['Korea, Republic of', 'KR', 'KOR'],
    name: 'Korea, Republic of',
    nationality: 'Korean',
    alpha2: 'KR',
    alpha3: 'KOR',
    iso3166: 'ISO 3166-2:KR',
    region: 'Asia',
    subRegion: 'Eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '030',
    eeaMember: false,
    economicArea: 3,
    countryCode: '410',
    language: '',
  },
  {
    id: '22efba65-43bd-420c-827e-2ee27fc452b7',
    identifiers: ['Kosovo', 'Republic of Kosovo', 'XK', 'XKK'],
    name: 'Kosovo (Repubic of Kosovo)',
    nationality: 'Kosovo',
    alpha2: 'XK',
    alpha3: 'XKK',
    iso3166: 'ISO 3166-2:XK',
    region: 'Europe',
    subRegion: 'Southeast Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '',
    subRegionCode: '',
    eeaMember: false,
    economicArea: 0,
    countryCode: '',
    language: 'Albanian, Serbian',
  },
  {
    id: 'd9e09d7c-40ee-4f0f-bffd-ddfa56488eef',
    identifiers: ['Kuwait', 'KW', 'KWT'],
    name: 'Kuwait',
    nationality: 'Kuwaiti',
    alpha2: 'KW',
    alpha3: 'KWT',
    iso3166: 'ISO 3166-2:KW',
    region: 'Asia',
    subRegion: 'Western Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '145',
    eeaMember: false,
    economicArea: 0,
    countryCode: '414',
    language: '',
  },
  {
    id: '23360053-c3fd-498f-92f2-f7b6143d7097',
    identifiers: ['Kyrgyzstan', 'KG', 'KGZ'],
    name: 'Kyrgyzstan',
    nationality: 'Kyrgyzstan',
    alpha2: 'KG',
    alpha3: 'KGZ',
    iso3166: 'ISO 3166-2:KG',
    region: 'Asia',
    subRegion: 'Central Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '143',
    eeaMember: false,
    economicArea: 0,
    countryCode: '417',
    language: '',
  },
  {
    id: '575ae145-9171-4ba3-89c3-4f5418f9a348',
    identifiers: ["Lao People's Democratic Republic", 'LA', 'LAO'],
    name: "Lao People's Democratic Republic",
    nationality: "Lao People's Democratic Republic",
    alpha2: 'LA',
    alpha3: 'LAO',
    iso3166: 'ISO 3166-2:LA',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '035',
    eeaMember: false,
    economicArea: 0,
    countryCode: '418',
    language: '',
  },
  {
    id: '0c471f9e-343c-4b06-b226-77431e312f03',
    identifiers: ['Latvia', 'LV', 'LVA'],
    name: 'Latvia',
    nationality: 'Latvian',
    alpha2: 'LV',
    alpha3: 'LVA',
    iso3166: 'ISO 3166-2:LV',
    region: 'Europe',
    subRegion: 'Northern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '154',
    eeaMember: true,
    economicArea: 1,
    countryCode: '428',
    language: '',
  },
  {
    id: 'fe857b2c-9199-4292-b17c-61f9b920a6b0',
    identifiers: ['Lebanon', 'LB', 'LBN'],
    name: 'Lebanon',
    nationality: 'Lebanese',
    alpha2: 'LB',
    alpha3: 'LBN',
    iso3166: 'ISO 3166-2:LB',
    region: 'Asia',
    subRegion: 'Western Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '145',
    eeaMember: false,
    economicArea: 0,
    countryCode: '422',
    language: '',
  },
  {
    id: '88721f24-dede-4c86-a740-b08cb1a8aa57',
    identifiers: ['Lesotho', 'LS', 'LSO'],
    name: 'Lesotho',
    nationality: 'Lesotho',
    alpha2: 'LS',
    alpha3: 'LSO',
    iso3166: 'ISO 3166-2:LS',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Southern Africa',
    intermediateRegionCode: '018',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '426',
    language: '',
  },
  {
    id: 'eaee750b-fc3a-440a-819d-e9d682203974',
    identifiers: ['Liberia', 'LR', 'LBR'],
    name: 'Liberia',
    nationality: 'Liberia',
    alpha2: 'LR',
    alpha3: 'LBR',
    iso3166: 'ISO 3166-2:LR',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Western Africa',
    intermediateRegionCode: '011',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '430',
    language: '',
  },
  {
    id: 'a479fb65-fde7-4013-9863-0e787e04a844',
    identifiers: ['Libya', 'LY', 'LBY'],
    name: 'Libya',
    nationality: 'Libyan',
    alpha2: 'LY',
    alpha3: 'LBY',
    iso3166: 'ISO 3166-2:LY',
    region: 'Africa',
    subRegion: 'Northern Africa',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '002',
    subRegionCode: '015',
    eeaMember: false,
    economicArea: 0,
    countryCode: '434',
    language: '',
  },
  {
    id: '2cac5bb1-b640-45f3-9349-369ef8b83266',
    identifiers: ['Liechtenstein', 'LI', 'LIE'],
    name: 'Liechtenstein',
    nationality: 'Liechtenstein',
    alpha2: 'LI',
    alpha3: 'LIE',
    iso3166: 'ISO 3166-2:LI',
    region: 'Europe',
    subRegion: 'Western Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '155',
    eeaMember: true,
    economicArea: 1,
    countryCode: '438',
    language: '',
  },
  {
    id: '03989f03-30b8-4e10-b901-e6fe7909d8e4',
    identifiers: ['Lithuania', 'LT', 'LTU'],
    name: 'Lithuania',
    nationality: 'Lithuanian',
    alpha2: 'LT',
    alpha3: 'LTU',
    iso3166: 'ISO 3166-2:LT',
    region: 'Europe',
    subRegion: 'Northern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '154',
    eeaMember: true,
    economicArea: 1,
    countryCode: '440',
    language: '',
  },
  {
    id: 'c74fa1ac-badd-464a-b32e-9bd2ca390ee6',
    identifiers: ['Luxembourg', 'LU', 'LUX'],
    name: 'Luxembourg',
    nationality: 'Luxembourg',
    alpha2: 'LU',
    alpha3: 'LUX',
    iso3166: 'ISO 3166-2:LU',
    region: 'Europe',
    subRegion: 'Western Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '155',
    eeaMember: true,
    economicArea: 1,
    countryCode: '442',
    language: '',
  },
  {
    id: '61f0e83f-2f9e-4e5e-9147-078df0b8be48',
    identifiers: ['Macao', 'MO', 'MAC'],
    name: 'Macao',
    nationality: 'Macao',
    alpha2: 'MO',
    alpha3: 'MAC',
    iso3166: 'ISO 3166-2:MO',
    region: 'Asia',
    subRegion: 'Eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '030',
    eeaMember: false,
    economicArea: 0,
    countryCode: '446',
    language: '',
  },
  {
    id: '33b765bd-cb12-4412-871b-3c9fc5e9a2ce',
    identifiers: ['Madagascar', 'MG', 'MDG'],
    name: 'Madagascar',
    nationality: 'Madagascar',
    alpha2: 'MG',
    alpha3: 'MDG',
    iso3166: 'ISO 3166-2:MG',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '450',
    language: '',
  },
  {
    id: 'c409cacd-e1e6-48f7-9b1d-f1af734081f6',
    identifiers: ['Malawi', 'MW', 'MWI'],
    name: 'Malawi',
    nationality: 'Malawi',
    alpha2: 'MW',
    alpha3: 'MWI',
    iso3166: 'ISO 3166-2:MW',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '454',
    language: '',
  },
  {
    id: '3475031d-c605-4229-b602-8ac66b801735',
    identifiers: ['Malaysia', 'MY', 'MYS'],
    name: 'Malaysia',
    nationality: 'Malaysian',
    alpha2: 'MY',
    alpha3: 'MYS',
    iso3166: 'ISO 3166-2:MY',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '035',
    eeaMember: false,
    economicArea: 0,
    countryCode: '458',
    language: '',
  },
  {
    id: '84fe4c61-4677-4b64-8340-57f025934887',
    identifiers: ['Maldives', 'MV', 'MDV'],
    name: 'Maldives',
    nationality: 'Maldives',
    alpha2: 'MV',
    alpha3: 'MDV',
    iso3166: 'ISO 3166-2:MV',
    region: 'Asia',
    subRegion: 'Southern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '034',
    eeaMember: false,
    economicArea: 0,
    countryCode: '462',
    language: '',
  },
  {
    id: '4e7ee700-e55f-4540-900d-7a8536346461',
    identifiers: ['Mali', 'ML', 'MLI'],
    name: 'Mali',
    nationality: 'Malian',
    alpha2: 'ML',
    alpha3: 'MLI',
    iso3166: 'ISO 3166-2:ML',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Western Africa',
    intermediateRegionCode: '011',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '466',
    language: '',
  },
  {
    id: 'b753eb88-f687-4b1e-98a6-9a1b25bf6172',
    identifiers: ['Malta', 'MT', 'MLT'],
    name: 'Malta',
    nationality: 'Maltese',
    alpha2: 'MT',
    alpha3: 'MLT',
    iso3166: 'ISO 3166-2:MT',
    region: 'Europe',
    subRegion: 'Southern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '039',
    eeaMember: true,
    economicArea: 1,
    countryCode: '470',
    language: '',
  },
  {
    id: '67d493a5-7913-4294-8855-e89d0a8ff04c',
    identifiers: ['Marshall Islands', 'MH', 'MHL'],
    name: 'Marshall Islands',
    nationality: 'Marshall Islands',
    alpha2: 'MH',
    alpha3: 'MHL',
    iso3166: 'ISO 3166-2:MH',
    region: 'Oceania',
    subRegion: 'Micronesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '057',
    eeaMember: false,
    economicArea: 0,
    countryCode: '584',
    language: '',
  },
  {
    id: '7a443eaf-5d09-4535-b8ef-ef58f7ff1894',
    identifiers: ['Martinique', 'MQ', 'MTQ'],
    name: 'Martinique',
    nationality: 'Martinique',
    alpha2: 'MQ',
    alpha3: 'MTQ',
    iso3166: 'ISO 3166-2:MQ',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '474',
    language: '',
  },
  {
    id: 'ff2a98d2-b4bf-4287-b879-aeada8b649d4',
    identifiers: ['Mauritania', 'MR', 'MRT'],
    name: 'Mauritania',
    nationality: 'Mauritania',
    alpha2: 'MR',
    alpha3: 'MRT',
    iso3166: 'ISO 3166-2:MR',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Western Africa',
    intermediateRegionCode: '011',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '478',
    language: '',
  },
  {
    id: '3f6f7b9c-c5ec-4735-8259-2b907e7594b1',
    identifiers: ['Mauritius', 'MU', 'MUS'],
    name: 'Mauritius',
    nationality: 'Mauritius',
    alpha2: 'MU',
    alpha3: 'MUS',
    iso3166: 'ISO 3166-2:MU',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '480',
    language: '',
  },
  {
    id: '9663395c-edff-4974-aac2-38c9ab5d99ca',
    identifiers: ['Mayotte', 'YT', 'MYT'],
    name: 'Mayotte',
    nationality: 'Mayotte',
    alpha2: 'YT',
    alpha3: 'MYT',
    iso3166: 'ISO 3166-2:YT',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '175',
    language: '',
  },
  {
    id: '2bceb546-5ee8-43bf-a005-a1e341d55500',
    identifiers: ['Mexico', 'MX', 'MEX'],
    name: 'Mexico',
    nationality: 'Mexican',
    alpha2: 'MX',
    alpha3: 'MEX',
    iso3166: 'ISO 3166-2:MX',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Central America',
    intermediateRegionCode: '013',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '484',
    language: '',
  },
  {
    id: '6d6d5d9a-16a4-4f4d-915a-9576aa2fb5b8',
    identifiers: ['Micronesia (Federated States of)', 'FM', 'FSM'],
    name: 'Micronesia (Federated States of)',
    nationality: 'Micronesia',
    alpha2: 'FM',
    alpha3: 'FSM',
    iso3166: 'ISO 3166-2:FM',
    region: 'Oceania',
    subRegion: 'Micronesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '057',
    eeaMember: false,
    economicArea: 0,
    countryCode: '583',
    language: '',
  },
  {
    id: '18978e68-85d4-4a9e-9988-bccc4d695849',
    identifiers: ['Moldova, Republic of', 'MD', 'MDA'],
    name: 'Moldova, Republic of',
    nationality: 'Moldovaian',
    alpha2: 'MD',
    alpha3: 'MDA',
    iso3166: 'ISO 3166-2:MD',
    region: 'Europe',
    subRegion: 'Eastern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '151',
    eeaMember: false,
    economicArea: 0,
    countryCode: '498',
    language: '',
  },
  {
    id: '6d340846-8f43-4d27-95dd-a01f1709ff4a',
    identifiers: ['Monaco', 'MC', 'MCO'],
    name: 'Monaco',
    nationality: 'Monaco',
    alpha2: 'MC',
    alpha3: 'MCO',
    iso3166: 'ISO 3166-2:MC',
    region: 'Europe',
    subRegion: 'Western Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '155',
    eeaMember: false,
    economicArea: 0,
    countryCode: '492',
    language: '',
  },
  {
    id: 'ffe20e57-9123-4bee-b32d-5b5ccd5c838d',
    identifiers: ['Mongolia', 'MN', 'MNG'],
    name: 'Mongolia',
    nationality: 'Mongolian',
    alpha2: 'MN',
    alpha3: 'MNG',
    iso3166: 'ISO 3166-2:MN',
    region: 'Asia',
    subRegion: 'Eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '030',
    eeaMember: false,
    economicArea: 0,
    countryCode: '496',
    language: '',
  },
  {
    id: 'f75b82c8-5bdb-4fa5-971e-b530cdf7a420',
    identifiers: ['Montenegro', 'ME', 'MNE'],
    name: 'Montenegro',
    nationality: 'Montenegro',
    alpha2: 'ME',
    alpha3: 'MNE',
    iso3166: 'ISO 3166-2:ME',
    region: 'Europe',
    subRegion: 'Southern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '039',
    eeaMember: false,
    economicArea: 0,
    countryCode: '499',
    language: '',
  },
  {
    id: 'f68a217b-bb22-459f-b1e6-721fe8580924',
    identifiers: ['Montserrat', 'MS', 'MSR'],
    name: 'Montserrat',
    nationality: 'Montserrat',
    alpha2: 'MS',
    alpha3: 'MSR',
    iso3166: 'ISO 3166-2:MS',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '500',
    language: '',
  },
  {
    id: '03893c33-d6a1-4dc7-8eac-0d59b13203a0',
    identifiers: ['Morocco', 'MA', 'MAR'],
    name: 'Morocco',
    nationality: 'Moroccan',
    alpha2: 'MA',
    alpha3: 'MAR',
    iso3166: 'ISO 3166-2:MA',
    region: 'Africa',
    subRegion: 'Northern Africa',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '002',
    subRegionCode: '015',
    eeaMember: false,
    economicArea: 0,
    countryCode: '504',
    language: '',
  },
  {
    id: 'ed4e43a7-ce6b-44a4-8d23-af64e556e582',
    identifiers: ['Mozambique', 'MZ', 'MOZ'],
    name: 'Mozambique',
    nationality: 'Mozambican',
    alpha2: 'MZ',
    alpha3: 'MOZ',
    iso3166: 'ISO 3166-2:MZ',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '508',
    language: '',
  },
  {
    id: 'b3e9bf98-9a9f-477f-aacd-00f7b4d1be0d',
    identifiers: ['Myanmar', 'MM', 'MMR'],
    name: 'Myanmar',
    nationality: 'Myanmar',
    alpha2: 'MM',
    alpha3: 'MMR',
    iso3166: 'ISO 3166-2:MM',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '035',
    eeaMember: false,
    economicArea: 0,
    countryCode: '104',
    language: '',
  },
  {
    id: '9b73bb21-d73a-4910-904d-6f06570cd540',
    identifiers: ['Namibia', 'NA', 'NAM'],
    name: 'Namibia',
    nationality: 'Namibian',
    alpha2: 'NA',
    alpha3: 'NAM',
    iso3166: 'ISO 3166-2:NA',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Southern Africa',
    intermediateRegionCode: '018',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '516',
    language: '',
  },
  {
    id: 'faf2a0e1-7588-440a-9acc-2e15fd6d271f',
    identifiers: ['Nauru', 'NR', 'NRU'],
    name: 'Nauru',
    nationality: 'Nauru',
    alpha2: 'NR',
    alpha3: 'NRU',
    iso3166: 'ISO 3166-2:NR',
    region: 'Oceania',
    subRegion: 'Micronesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '057',
    eeaMember: false,
    economicArea: 0,
    countryCode: '520',
    language: '',
  },
  {
    id: '116f50f0-760a-463a-bae5-783ec197ca6b',
    identifiers: ['Nepal', 'NP', 'NPL'],
    name: 'Nepal',
    nationality: 'Nepalese',
    alpha2: 'NP',
    alpha3: 'NPL',
    iso3166: 'ISO 3166-2:NP',
    region: 'Asia',
    subRegion: 'Southern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '034',
    eeaMember: false,
    economicArea: 0,
    countryCode: '524',
    language: '',
  },
  {
    id: '02082d41-8efe-4947-b2c3-082b2f52f8d7',
    identifiers: ['Netherlands', 'NL', 'NLD'],
    name: 'Netherlands',
    nationality: 'Dutch',
    alpha2: 'NL',
    alpha3: 'NLD',
    iso3166: 'ISO 3166-2:NL',
    region: 'Europe',
    subRegion: 'Western Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '155',
    eeaMember: true,
    economicArea: 1,
    countryCode: '528',
    language: '',
  },
  {
    id: 'af936d53-8bfb-4e66-b613-7591f85bbd7f',
    identifiers: ['New Caledonia', 'NC', 'NCL'],
    name: 'New Caledonia',
    nationality: 'New Caledonia',
    alpha2: 'NC',
    alpha3: 'NCL',
    iso3166: 'ISO 3166-2:NC',
    region: 'Oceania',
    subRegion: 'Melanesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '054',
    eeaMember: false,
    economicArea: 0,
    countryCode: '540',
    language: '',
  },
  {
    id: '82630228-f736-484f-9bc2-3363d8028c6d',
    identifiers: ['New Zealand', 'NZ', 'NZL'],
    name: 'New Zealand',
    nationality: 'New Zealand',
    alpha2: 'NZ',
    alpha3: 'NZL',
    iso3166: 'ISO 3166-2:NZ',
    region: 'Oceania',
    subRegion: 'Australia and New Zealand',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '053',
    eeaMember: false,
    economicArea: 3,
    countryCode: '554',
    language: '',
  },
  {
    id: '46c056b2-88d4-4341-ae5e-b3b7146e5c8a',
    identifiers: ['Nicaragua', 'NI', 'NIC'],
    name: 'Nicaragua',
    nationality: 'Nicaraguan',
    alpha2: 'NI',
    alpha3: 'NIC',
    iso3166: 'ISO 3166-2:NI',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Central America',
    intermediateRegionCode: '013',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '558',
    language: '',
  },
  {
    id: '884f0c04-6f64-4143-88a5-f1ee5a87edf9',
    identifiers: ['Niger', 'NE', 'NER'],
    name: 'Niger',
    nationality: 'Niger',
    alpha2: 'NE',
    alpha3: 'NER',
    iso3166: 'ISO 3166-2:NE',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Western Africa',
    intermediateRegionCode: '011',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '562',
    language: '',
  },
  {
    id: '1d95c83d-5421-492b-b123-d951bde9a5a0',
    identifiers: ['Nigeria', 'NG', 'NGA'],
    name: 'Nigeria',
    nationality: 'Nigerian',
    alpha2: 'NG',
    alpha3: 'NGA',
    iso3166: 'ISO 3166-2:NG',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Western Africa',
    intermediateRegionCode: '011',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '566',
    language: '',
  },
  {
    id: '26c2582f-e707-4a5e-9206-156d9d91736b',
    identifiers: ['Niue', 'NU', 'NIU'],
    name: 'Niue',
    nationality: 'Niue',
    alpha2: 'NU',
    alpha3: 'NIU',
    iso3166: 'ISO 3166-2:NU',
    region: 'Oceania',
    subRegion: 'Polynesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '061',
    eeaMember: false,
    economicArea: 0,
    countryCode: '570',
    language: '',
  },
  {
    id: '2e2ae43e-2250-4e09-8972-be2ee3269a57',
    identifiers: ['Norfolk Island', 'NF', 'NFK'],
    name: 'Norfolk Island',
    nationality: 'Norfolk Island',
    alpha2: 'NF',
    alpha3: 'NFK',
    iso3166: 'ISO 3166-2:NF',
    region: 'Oceania',
    subRegion: 'Australia and New Zealand',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '053',
    eeaMember: false,
    economicArea: 0,
    countryCode: '574',
    language: '',
  },
  {
    id: '6759634a-37b2-4222-a9a0-cced832e03f8',
    identifiers: ['North Macedonia', 'MK', 'MKD'],
    name: 'North Macedonia',
    nationality: 'North Macedonia',
    alpha2: 'MK',
    alpha3: 'MKD',
    iso3166: 'ISO 3166-2:MK',
    region: 'Europe',
    subRegion: 'Southern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '039',
    eeaMember: false,
    economicArea: 0,
    countryCode: '807',
    language: '',
  },
  {
    id: 'ce9fac1b-1fa8-444a-9a4f-3e6290c0c46c',
    identifiers: ['Northern Mariana Islands', 'MP', 'MNP'],
    name: 'Northern Mariana Islands',
    nationality: 'Northern Mariana Islands',
    alpha2: 'MP',
    alpha3: 'MNP',
    iso3166: 'ISO 3166-2:MP',
    region: 'Oceania',
    subRegion: 'Micronesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '057',
    eeaMember: false,
    economicArea: 0,
    countryCode: '580',
    language: '',
  },
  {
    id: 'ac082f62-88d5-4c8a-a7ce-f39afc6c5d25',
    identifiers: ['Norway', 'NO', 'NOR'],
    name: 'Norway',
    nationality: 'Norwegian',
    alpha2: 'NO',
    alpha3: 'NOR',
    iso3166: 'ISO 3166-2:NO',
    region: 'Europe',
    subRegion: 'Northern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '154',
    eeaMember: true,
    economicArea: 1,
    countryCode: '578',
    language: '',
  },
  {
    id: '286dd0bc-63fa-49de-816a-ddc8662f923f',
    identifiers: ['Oman', 'OM', 'OMN'],
    name: 'Oman',
    nationality: 'Oman',
    alpha2: 'OM',
    alpha3: 'OMN',
    iso3166: 'ISO 3166-2:OM',
    region: 'Asia',
    subRegion: 'Western Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '145',
    eeaMember: false,
    economicArea: 0,
    countryCode: '512',
    language: '',
  },
  {
    id: '187f760b-ab45-4d01-aa9a-5b5486436c84',
    identifiers: ['Pakistan', 'PK', 'PAK'],
    name: 'Pakistan',
    nationality: 'Pakistani',
    alpha2: 'PK',
    alpha3: 'PAK',
    iso3166: 'ISO 3166-2:PK',
    region: 'Asia',
    subRegion: 'Southern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '034',
    eeaMember: false,
    economicArea: 0,
    countryCode: '586',
    language: '',
  },
  {
    id: 'db5fac08-cfeb-4d37-8b0d-b7f5d143e6fd',
    identifiers: ['Palau', 'PW', 'PLW'],
    name: 'Palau',
    nationality: 'Palau',
    alpha2: 'PW',
    alpha3: 'PLW',
    iso3166: 'ISO 3166-2:PW',
    region: 'Oceania',
    subRegion: 'Micronesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '057',
    eeaMember: false,
    economicArea: 0,
    countryCode: '585',
    language: '',
  },
  {
    id: '94f779ea-cb3f-4a03-8edd-87fad5b9ed9d',
    identifiers: ['Palestine, State of', 'PS', 'PSE'],
    name: 'Palestine, State of',
    nationality: 'Palestinian',
    alpha2: 'PS',
    alpha3: 'PSE',
    iso3166: 'ISO 3166-2:PS',
    region: 'Asia',
    subRegion: 'Western Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '145',
    eeaMember: false,
    economicArea: 0,
    countryCode: '275',
    language: '',
  },
  {
    id: 'a99e13d5-9227-4995-9e32-c4c83d1f9c89',
    identifiers: ['Panama', 'PA', 'PAN'],
    name: 'Panama',
    nationality: 'Panamanian',
    alpha2: 'PA',
    alpha3: 'PAN',
    iso3166: 'ISO 3166-2:PA',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Central America',
    intermediateRegionCode: '013',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '591',
    language: '',
  },
  {
    id: 'a71b9119-3cfb-4c7c-989c-93336dd043d1',
    identifiers: ['Papua New Guinea', 'PG', 'PNG'],
    name: 'Papua New Guinea',
    nationality: 'Papua New Guinea',
    alpha2: 'PG',
    alpha3: 'PNG',
    iso3166: 'ISO 3166-2:PG',
    region: 'Oceania',
    subRegion: 'Melanesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '054',
    eeaMember: false,
    economicArea: 0,
    countryCode: '598',
    language: '',
  },
  {
    id: '08c3f5e7-dbea-48a8-bc26-3049ef750589',
    identifiers: ['Paraguay', 'PY', 'PRY'],
    name: 'Paraguay',
    nationality: 'Paraguayan',
    alpha2: 'PY',
    alpha3: 'PRY',
    iso3166: 'ISO 3166-2:PY',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'South America',
    intermediateRegionCode: '005',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '600',
    language: '',
  },
  {
    id: '37b56bb8-c56a-4087-9a61-206523f6f40a',
    identifiers: ['Peru', 'PE', 'PER'],
    name: 'Peru',
    nationality: 'Peruvian',
    alpha2: 'PE',
    alpha3: 'PER',
    iso3166: 'ISO 3166-2:PE',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'South America',
    intermediateRegionCode: '005',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '604',
    language: '',
  },
  {
    id: '3731b19e-283d-4a4e-951b-7eb6329818e2',
    identifiers: ['Philippines', 'PH', 'PHL'],
    name: 'Philippines',
    nationality: 'Philippine',
    alpha2: 'PH',
    alpha3: 'PHL',
    iso3166: 'ISO 3166-2:PH',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '035',
    eeaMember: false,
    economicArea: 0,
    countryCode: '608',
    language: '',
  },
  {
    id: '1a54c648-d9c7-4b95-96f1-f422d6621beb',
    identifiers: ['Pitcairn', 'PN', 'PCN'],
    name: 'Pitcairn',
    nationality: 'Pitcairn',
    alpha2: 'PN',
    alpha3: 'PCN',
    iso3166: 'ISO 3166-2:PN',
    region: 'Oceania',
    subRegion: 'Polynesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '061',
    eeaMember: false,
    economicArea: 0,
    countryCode: '612',
    language: '',
  },
  {
    id: '86d737ca-35b8-47d5-8f11-b1d41d4bc12c',
    identifiers: ['Poland', 'PL', 'POL'],
    name: 'Poland',
    nationality: 'Polish',
    alpha2: 'PL',
    alpha3: 'POL',
    iso3166: 'ISO 3166-2:PL',
    region: 'Europe',
    subRegion: 'Eastern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '151',
    eeaMember: true,
    economicArea: 1,
    countryCode: '616',
    language: '',
  },
  {
    id: '0abb3888-3ffb-462e-a697-022d41624f1d',
    identifiers: ['Portugal', 'PT', 'PRT'],
    name: 'Portugal',
    nationality: 'Portuguese',
    alpha2: 'PT',
    alpha3: 'PRT',
    iso3166: 'ISO 3166-2:PT',
    region: 'Europe',
    subRegion: 'Southern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '039',
    eeaMember: true,
    economicArea: 1,
    countryCode: '620',
    language: '',
  },
  {
    id: '057ee047-0d24-45af-ab87-df9856ea1e62',
    identifiers: ['Puerto Rico', 'PR', 'PRI'],
    name: 'Puerto Rico',
    nationality: 'Puerto Rico',
    alpha2: 'PR',
    alpha3: 'PRI',
    iso3166: 'ISO 3166-2:PR',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '630',
    language: '',
  },
  {
    id: '67a89cef-689a-425a-9082-0dd73dedbe03',
    identifiers: ['Qatar', 'QA', 'QAT'],
    name: 'Qatar',
    nationality: 'Qatar',
    alpha2: 'QA',
    alpha3: 'QAT',
    iso3166: 'ISO 3166-2:QA',
    region: 'Asia',
    subRegion: 'Western Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '145',
    eeaMember: false,
    economicArea: 0,
    countryCode: '634',
    language: '',
  },
  {
    id: 'b4e7fa0c-c163-4a94-b7a2-76bc802acbce',
    identifiers: ['Réunion', 'RE', 'REU'],
    name: 'Réunion',
    nationality: 'Réunion',
    alpha2: 'RE',
    alpha3: 'REU',
    iso3166: 'ISO 3166-2:RE',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '638',
    language: '',
  },
  {
    id: 'd28c2ca9-4d59-41e2-8131-49477e484ebe',
    identifiers: ['Romania', 'RO', 'ROU'],
    name: 'Romania',
    nationality: 'Romanian',
    alpha2: 'RO',
    alpha3: 'ROU',
    iso3166: 'ISO 3166-2:RO',
    region: 'Europe',
    subRegion: 'Eastern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '151',
    eeaMember: true,
    economicArea: 1,
    countryCode: '642',
    language: '',
  },
  {
    id: 'dc09e79a-ffae-4629-8215-3b134e9d9db4',
    identifiers: ['Russian Federation', 'RU', 'RUS'],
    name: 'Russian Federation',
    nationality: 'Russian',
    alpha2: 'RU',
    alpha3: 'RUS',
    iso3166: 'ISO 3166-2:RU',
    region: 'Europe',
    subRegion: 'Eastern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '151',
    eeaMember: false,
    economicArea: 0,
    countryCode: '643',
    language: '',
  },
  {
    id: 'bfef74c5-e51f-4ff7-bc51-dfc01ee9e687',
    identifiers: ['Rwanda', 'RW', 'RWA'],
    name: 'Rwanda',
    nationality: 'Rwanda',
    alpha2: 'RW',
    alpha3: 'RWA',
    iso3166: 'ISO 3166-2:RW',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '646',
    language: '',
  },
  {
    id: '80abb147-2621-403b-bf53-879b6c06a6c4',
    identifiers: ['Saint Barthélemy', 'BL', 'BLM'],
    name: 'Saint Barthélemy',
    nationality: 'Saint Barthélemy',
    alpha2: 'BL',
    alpha3: 'BLM',
    iso3166: 'ISO 3166-2:BL',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '652',
    language: '',
  },
  {
    id: 'b0468b0f-def2-478e-8ae5-dce82f202c12',
    identifiers: ['Saint Helena, Ascension and Tristan da Cunha', 'SH', 'SHN'],
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    nationality: 'Saint Helena',
    alpha2: 'SH',
    alpha3: 'SHN',
    iso3166: 'ISO 3166-2:SH',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Western Africa',
    intermediateRegionCode: '011',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '654',
    language: '',
  },
  {
    id: 'ce06f450-dc7b-4f03-ae24-0c30aa0db5d7',
    identifiers: ['Saint Kitts and Nevis', 'KN', 'KNA'],
    name: 'Saint Kitts and Nevis',
    nationality: 'Saint Kitts and Nevis',
    alpha2: 'KN',
    alpha3: 'KNA',
    iso3166: 'ISO 3166-2:KN',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '659',
    language: '',
  },
  {
    id: '4a74a524-159f-4cf2-ac66-811f9526fb9c',
    identifiers: ['Saint Lucia', 'LC', 'LCA'],
    name: 'Saint Lucia',
    nationality: 'Saint Lucia',
    alpha2: 'LC',
    alpha3: 'LCA',
    iso3166: 'ISO 3166-2:LC',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '662',
    language: '',
  },
  {
    id: '792fe604-e59a-4131-aaac-c57ed15f0b31',
    identifiers: ['Saint Martin (French part)', 'MF', 'MAF'],
    name: 'Saint Martin',
    nationality: 'Saint Martin',
    alpha2: 'MF',
    alpha3: 'MAF',
    iso3166: 'ISO 3166-2:MF',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '663',
    language: '',
  },
  {
    id: 'c50f92ae-77ad-4964-b9da-403e41554b81',
    identifiers: ['Saint Pierre and Miquelon', 'PM', 'SPM'],
    name: 'Saint Pierre and Miquelon',
    nationality: 'Saint Pierre and Miquelon',
    alpha2: 'PM',
    alpha3: 'SPM',
    iso3166: 'ISO 3166-2:PM',
    region: 'Americas',
    subRegion: 'Northern America',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '019',
    subRegionCode: '021',
    eeaMember: false,
    economicArea: 0,
    countryCode: '666',
    language: '',
  },
  {
    id: '29d1b244-75a7-4510-8dd3-f862addb3625',
    identifiers: ['Saint Vincent and the Grenadines', 'VC', 'VCT'],
    name: 'Saint Vincent and the Grenadines',
    nationality: 'Saint Vincent and the Grenadines',
    alpha2: 'VC',
    alpha3: 'VCT',
    iso3166: 'ISO 3166-2:VC',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '670',
    language: '',
  },
  {
    id: '0ab64ff4-065d-4667-a698-a5a1f8af2ef0',
    identifiers: ['Samoa', 'WS', 'WSM'],
    name: 'Samoa',
    nationality: 'Samoa',
    alpha2: 'WS',
    alpha3: 'WSM',
    iso3166: 'ISO 3166-2:WS',
    region: 'Oceania',
    subRegion: 'Polynesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '061',
    eeaMember: false,
    economicArea: 0,
    countryCode: '882',
    language: '',
  },
  {
    id: 'd1a52277-a914-425d-a4ba-e036cbd00c1a',
    identifiers: ['San Marino', 'SM', 'SMR'],
    name: 'San Marino',
    nationality: 'San Marino',
    alpha2: 'SM',
    alpha3: 'SMR',
    iso3166: 'ISO 3166-2:SM',
    region: 'Europe',
    subRegion: 'Southern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '039',
    eeaMember: false,
    economicArea: 0,
    countryCode: '674',
    language: '',
  },
  {
    id: '4e5f4571-5aee-4117-9cc7-057a8f67d705',
    identifiers: ['Sao Tome and Principe', 'ST', 'STP'],
    name: 'Sao Tome and Principe',
    nationality: 'Sao Tome and Principe',
    alpha2: 'ST',
    alpha3: 'STP',
    iso3166: 'ISO 3166-2:ST',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Middle Africa',
    intermediateRegionCode: '017',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '678',
    language: '',
  },
  {
    id: 'a1315fb9-5f1b-4f36-ab3b-f616108fbb47',
    identifiers: ['Saudi Arabia', 'SA', 'SAU'],
    name: 'Saudi Arabia',
    nationality: 'Saudi',
    alpha2: 'SA',
    alpha3: 'SAU',
    iso3166: 'ISO 3166-2:SA',
    region: 'Asia',
    subRegion: 'Western Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '145',
    eeaMember: false,
    economicArea: 0,
    countryCode: '682',
    language: '',
  },
  {
    id: '2a1b4de1-d03b-4d27-9246-9be5f22cfd77',
    identifiers: ['Senegal', 'SN', 'SEN'],
    name: 'Senegal',
    nationality: 'Senegal',
    alpha2: 'SN',
    alpha3: 'SEN',
    iso3166: 'ISO 3166-2:SN',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Western Africa',
    intermediateRegionCode: '011',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '686',
    language: '',
  },
  {
    id: 'db62c844-a21b-4412-84fa-6f084894332f',
    identifiers: ['Serbia', 'RS', 'SRB'],
    name: 'Serbia',
    nationality: 'Serbian',
    alpha2: 'RS',
    alpha3: 'SRB',
    iso3166: 'ISO 3166-2:RS',
    region: 'Europe',
    subRegion: 'Southern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '039',
    eeaMember: false,
    economicArea: 0,
    countryCode: '688',
    language: '',
  },
  {
    id: '0e088139-c4bf-4b26-bd22-578681f726b3',
    identifiers: ['Seychelles', 'SC', 'SYC'],
    name: 'Seychelles',
    nationality: 'Seychelles',
    alpha2: 'SC',
    alpha3: 'SYC',
    iso3166: 'ISO 3166-2:SC',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '690',
    language: '',
  },
  {
    id: '5744a8b1-0f5d-4f52-b67d-8f945e099e72',
    identifiers: ['Sierra Leone', 'SL', 'SLE'],
    name: 'Sierra Leone',
    nationality: 'Sierra Leone',
    alpha2: 'SL',
    alpha3: 'SLE',
    iso3166: 'ISO 3166-2:SL',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Western Africa',
    intermediateRegionCode: '011',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '694',
    language: '',
  },
  {
    id: '1ad911f4-b839-44bf-90ac-24f572b717fb',
    identifiers: ['Singapore', 'SG', 'SGP'],
    name: 'Singapore',
    nationality: 'Singaporian',
    alpha2: 'SG',
    alpha3: 'SGP',
    iso3166: 'ISO 3166-2:SG',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '035',
    eeaMember: false,
    economicArea: 3,
    countryCode: '702',
    language: '',
  },
  {
    id: '7f58b00b-bf35-4c53-ab5f-f82eff40ee1c',
    identifiers: ['Sint Maarten (Dutch part)', 'SX', 'SXM'],
    name: 'Sint Maarten (Dutch part)',
    nationality: 'Sint Maarten (Dutch part)',
    alpha2: 'SX',
    alpha3: 'SXM',
    iso3166: 'ISO 3166-2:SX',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '534',
    language: '',
  },
  {
    id: 'c2f8c7ec-16fd-40c1-9762-2d17bd570312',
    identifiers: ['Slovakia', 'SK', 'SVK'],
    name: 'Slovakia',
    nationality: 'Slovakian',
    alpha2: 'SK',
    alpha3: 'SVK',
    iso3166: 'ISO 3166-2:SK',
    region: 'Europe',
    subRegion: 'Eastern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '151',
    eeaMember: true,
    economicArea: 1,
    countryCode: '703',
    language: '',
  },
  {
    id: 'b486f971-0683-49dd-9e15-3c9a5d6b9934',
    identifiers: ['Slovenia', 'SI', 'SVN'],
    name: 'Slovenia',
    nationality: 'Slovenian',
    alpha2: 'SI',
    alpha3: 'SVN',
    iso3166: 'ISO 3166-2:SI',
    region: 'Europe',
    subRegion: 'Southern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '039',
    eeaMember: true,
    economicArea: 1,
    countryCode: '705',
    language: '',
  },
  {
    id: 'cb22c280-83c3-44f5-bbf5-7e74d75c33f5',
    identifiers: ['Solomon Islands', 'SB', 'SLB'],
    name: 'Solomon Islands',
    nationality: 'Solomon Islands',
    alpha2: 'SB',
    alpha3: 'SLB',
    iso3166: 'ISO 3166-2:SB',
    region: 'Oceania',
    subRegion: 'Melanesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '054',
    eeaMember: false,
    economicArea: 0,
    countryCode: '090',
    language: '',
  },
  {
    id: 'd67c16ad-ab47-4dbd-a136-79eb9fa43369',
    identifiers: ['Somalia', 'SO', 'SOM'],
    name: 'Somalia',
    nationality: 'Somalian',
    alpha2: 'SO',
    alpha3: 'SOM',
    iso3166: 'ISO 3166-2:SO',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '706',
    language: '',
  },
  {
    id: 'ac6faa12-381e-4677-aab3-ffddcd186f4e',
    identifiers: ['South Africa', 'ZA', 'ZAF'],
    name: 'South Africa',
    nationality: 'South African',
    alpha2: 'ZA',
    alpha3: 'ZAF',
    iso3166: 'ISO 3166-2:ZA',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Southern Africa',
    intermediateRegionCode: '018',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '710',
    language: '',
  },
  {
    id: '4e687bd6-7d32-458c-a670-6c2bd57f8963',
    identifiers: ['South Georgia and the South Sandwich Islands', 'GS', 'SGS'],
    name: 'South Georgia and the South Sandwich Islands',
    nationality: 'South Georgian',
    alpha2: 'GS',
    alpha3: 'SGS',
    iso3166: 'ISO 3166-2:GS',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'South America',
    intermediateRegionCode: '005',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '239',
    language: '',
  },
  {
    id: 'cf4d78ce-1a21-47e3-9a67-c32cb45b94f3',
    identifiers: ['South Sudan', 'SS', 'SSD'],
    name: 'South Sudan',
    nationality: 'Sudanese',
    alpha2: 'SS',
    alpha3: 'SSD',
    iso3166: 'ISO 3166-2:SS',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '728',
    language: '',
  },
  {
    id: 'bd8086a8-20d0-413b-aad9-9e73f1269a70',
    identifiers: ['Spain', 'ES', 'ESP'],
    name: 'Spain',
    nationality: 'Spanish',
    alpha2: 'ES',
    alpha3: 'ESP',
    iso3166: 'ISO 3166-2:ES',
    region: 'Europe',
    subRegion: 'Southern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '039',
    eeaMember: true,
    economicArea: 1,
    countryCode: '724',
    language: 'Spanish',
  },
  {
    id: 'b6665229-3fee-44fc-b356-9fa9c008c5dc',
    identifiers: ['Sri Lanka', 'LK', 'LKA'],
    name: 'Sri Lanka',
    nationality: 'Sri Lankan',
    alpha2: 'LK',
    alpha3: 'LKA',
    iso3166: 'ISO 3166-2:LK',
    region: 'Asia',
    subRegion: 'Southern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '034',
    eeaMember: false,
    economicArea: 0,
    countryCode: '144',
    language: '',
  },
  {
    id: 'b104b507-f0c2-4bca-a0b6-3fd4eb9ff908',
    identifiers: ['Sudan', 'SD', 'SDN'],
    name: 'Sudan',
    nationality: 'Sudanese',
    alpha2: 'SD',
    alpha3: 'SDN',
    iso3166: 'ISO 3166-2:SD',
    region: 'Africa',
    subRegion: 'Northern Africa',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '002',
    subRegionCode: '015',
    eeaMember: false,
    economicArea: 0,
    countryCode: '729',
    language: '',
  },
  {
    id: '7f66d728-77a2-4c4d-a3fb-ece0927f7016',
    identifiers: ['Suriname', 'SR', 'SUR'],
    name: 'Suriname',
    nationality: 'Suriname',
    alpha2: 'SR',
    alpha3: 'SUR',
    iso3166: 'ISO 3166-2:SR',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'South America',
    intermediateRegionCode: '005',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '740',
    language: '',
  },
  {
    id: 'cb5bb7e3-806b-4a1c-91ae-ad0fa51cb085',
    identifiers: ['Svalbard and Jan Mayen', 'SJ', 'SJM'],
    name: 'Svalbard and Jan Mayen',
    nationality: 'Svalbard and Jan Mayen',
    alpha2: 'SJ',
    alpha3: 'SJM',
    iso3166: 'ISO 3166-2:SJ',
    region: 'Europe',
    subRegion: 'Northern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '154',
    eeaMember: false,
    economicArea: 0,
    countryCode: '744',
    language: '',
  },
  {
    id: 'feac40de-0df8-4065-b1b7-8f20e94745a5',
    identifiers: ['Sweden', 'SE', 'SWE'],
    name: 'Sweden',
    nationality: 'Swedish',
    alpha2: 'SE',
    alpha3: 'SWE',
    iso3166: 'ISO 3166-2:SE',
    region: 'Europe',
    subRegion: 'Northern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '154',
    eeaMember: true,
    economicArea: 1,
    countryCode: '752',
    language: '',
  },
  {
    id: '8809c45e-e338-4621-9ae0-91149ca7c5ed',
    identifiers: ['Switzerland', 'CH', 'CHE'],
    name: 'Switzerland',
    nationality: 'Swiss',
    alpha2: 'CH',
    alpha3: 'CHE',
    iso3166: 'ISO 3166-2:CH',
    region: 'Europe',
    subRegion: 'Western Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '155',
    eeaMember: true,
    economicArea: 2,
    countryCode: '756',
    language: '',
  },
  {
    id: 'ee44bb6c-f728-4b57-9660-b6b7e6d3b53f',
    identifiers: ['Syrian Arab Republic', 'SY', 'SYR'],
    name: 'Syrian Arab Republic',
    nationality: 'Syrian Arab Republic',
    alpha2: 'SY',
    alpha3: 'SYR',
    iso3166: 'ISO 3166-2:SY',
    region: 'Asia',
    subRegion: 'Western Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '145',
    eeaMember: false,
    economicArea: 0,
    countryCode: '760',
    language: '',
  },
  {
    id: '97452ade-3d77-4542-a14d-48f88955098c',
    identifiers: ['Taiwan, Province of China', 'TW', 'TWN'],
    name: 'Taiwan, Province of China',
    nationality: 'Taiwan, Province of China',
    alpha2: 'TW',
    alpha3: 'TWN',
    iso3166: 'ISO 3166-2:TW',
    region: 'Asia',
    subRegion: 'Eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '030',
    eeaMember: false,
    economicArea: 0,
    countryCode: '158',
    language: '',
  },
  {
    id: '5a71cfaa-dde6-4f31-a723-8155b61b2218',
    identifiers: ['Tajikistan', 'TJ', 'TJK'],
    name: 'Tajikistan',
    nationality: 'Tajikistani',
    alpha2: 'TJ',
    alpha3: 'TJK',
    iso3166: 'ISO 3166-2:TJ',
    region: 'Asia',
    subRegion: 'Central Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '143',
    eeaMember: false,
    economicArea: 0,
    countryCode: '762',
    language: '',
  },
  {
    id: 'a151f8fb-3b9d-4179-821b-e42b7a890964',
    identifiers: ['Tanzania, United Republic of', 'TZ', 'TZA'],
    name: 'Tanzania, United Republic of',
    nationality: 'Tanzanian',
    alpha2: 'TZ',
    alpha3: 'TZA',
    iso3166: 'ISO 3166-2:TZ',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '834',
    language: '',
  },
  {
    id: '03fb9e21-fbc8-436e-a742-1b98050e4cc6',
    identifiers: ['Thailand', 'TH', 'THA'],
    name: 'Thailand',
    nationality: 'Thai',
    alpha2: 'TH',
    alpha3: 'THA',
    iso3166: 'ISO 3166-2:TH',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '035',
    eeaMember: false,
    economicArea: 0,
    countryCode: '764',
    language: '',
  },
  {
    id: 'd0cc8f7d-32b1-47ad-bb2b-b9593b1198f2',
    identifiers: ['Timor-Leste', 'TL', 'TLS'],
    name: 'Timor-Leste',
    nationality: 'Timor-Leste',
    alpha2: 'TL',
    alpha3: 'TLS',
    iso3166: 'ISO 3166-2:TL',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '035',
    eeaMember: false,
    economicArea: 0,
    countryCode: '626',
    language: '',
  },
  {
    id: 'f85ced09-b10e-411d-8c5b-4fcbfb14d680',
    identifiers: ['Togo', 'TG', 'TGO'],
    name: 'Togo',
    nationality: 'Tongan',
    alpha2: 'TG',
    alpha3: 'TGO',
    iso3166: 'ISO 3166-2:TG',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Western Africa',
    intermediateRegionCode: '011',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '768',
    language: '',
  },
  {
    id: '0757a91f-06ec-4706-9269-d58af25ae6c8',
    identifiers: ['Tokelau', 'TK', 'TKL'],
    name: 'Tokelau',
    nationality: 'Tokelau',
    alpha2: 'TK',
    alpha3: 'TKL',
    iso3166: 'ISO 3166-2:TK',
    region: 'Oceania',
    subRegion: 'Polynesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '061',
    eeaMember: false,
    economicArea: 0,
    countryCode: '772',
    language: '',
  },
  {
    id: '8792944b-b470-4bee-8e2f-609a4f82f098',
    identifiers: ['Tonga', 'TO', 'TON'],
    name: 'Tonga',
    nationality: 'Tongan',
    alpha2: 'TO',
    alpha3: 'TON',
    iso3166: 'ISO 3166-2:TO',
    region: 'Oceania',
    subRegion: 'Polynesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '061',
    eeaMember: false,
    economicArea: 0,
    countryCode: '776',
    language: '',
  },
  {
    id: '4788d56e-01d3-4eb1-89a1-a718359f9277',
    identifiers: ['Trinidad and Tobago', 'TT', 'TTO'],
    name: 'Trinidad and Tobago',
    nationality: 'Trinidad',
    alpha2: 'TT',
    alpha3: 'TTO',
    iso3166: 'ISO 3166-2:TT',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '780',
    language: '',
  },
  {
    id: 'e40a8613-74b1-4240-839f-58deb1adda89',
    identifiers: ['Tunisia', 'TN', 'TUN'],
    name: 'Tunisia',
    nationality: 'Tunisian',
    alpha2: 'TN',
    alpha3: 'TUN',
    iso3166: 'ISO 3166-2:TN',
    region: 'Africa',
    subRegion: 'Northern Africa',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '002',
    subRegionCode: '015',
    eeaMember: false,
    economicArea: 0,
    countryCode: '788',
    language: '',
  },
  {
    id: 'e9e20c68-4af8-4e57-beeb-4fedaa7b91df',
    identifiers: ['Turkey', 'TR', 'TUR'],
    name: 'Turkey',
    nationality: 'Turkish',
    alpha2: 'TR',
    alpha3: 'TUR',
    iso3166: 'ISO 3166-2:TR',
    region: 'Asia',
    subRegion: 'Western Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '145',
    eeaMember: false,
    economicArea: 0,
    countryCode: '792',
    language: '',
  },
  {
    id: '0d29aa64-3543-4cea-ad35-21eaee3f621d',
    identifiers: ['Turkmenistan', 'TM', 'TKM'],
    name: 'Turkmenistan',
    nationality: 'Turkmenistan',
    alpha2: 'TM',
    alpha3: 'TKM',
    iso3166: 'ISO 3166-2:TM',
    region: 'Asia',
    subRegion: 'Central Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '143',
    eeaMember: false,
    economicArea: 0,
    countryCode: '795',
    language: '',
  },
  {
    id: 'c11eb094-dff7-4952-afc8-74f2dbba5711',
    identifiers: ['Turks and Caicos Islands', 'TC', 'TCA'],
    name: 'Turks and Caicos Islands',
    nationality: 'Turks and Caicos Islands',
    alpha2: 'TC',
    alpha3: 'TCA',
    iso3166: 'ISO 3166-2:TC',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '796',
    language: '',
  },
  {
    id: '585df228-84c4-483a-be2d-4dabee8d1b63',
    identifiers: ['Tuvalu', 'TV', 'TUV'],
    name: 'Tuvalu',
    nationality: 'Tuvalu',
    alpha2: 'TV',
    alpha3: 'TUV',
    iso3166: 'ISO 3166-2:TV',
    region: 'Oceania',
    subRegion: 'Polynesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '061',
    eeaMember: false,
    economicArea: 0,
    countryCode: '798',
    language: '',
  },
  {
    id: 'a5ed6c76-4ae8-46a7-991e-4ab004077505',
    identifiers: ['Uganda', 'UG', 'UGA'],
    name: 'Uganda',
    nationality: 'Ugandan',
    alpha2: 'UG',
    alpha3: 'UGA',
    iso3166: 'ISO 3166-2:UG',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '800',
    language: '',
  },
  {
    id: '2c19d9a7-bba6-414a-ae24-5fbd52dc16bb',
    identifiers: ['Ukraine', 'UA', 'UKR'],
    name: 'Ukraine',
    nationality: 'Ukrainian',
    alpha2: 'UA',
    alpha3: 'UKR',
    iso3166: 'ISO 3166-2:UA',
    region: 'Europe',
    subRegion: 'Eastern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '151',
    eeaMember: false,
    economicArea: 0,
    countryCode: '804',
    language: '',
  },
  {
    id: '5059df19-aa2c-47ad-8433-1b55c3f53b73',
    identifiers: ['United Arab Emirates', 'AE', 'ARE'],
    name: 'United Arab Emirates',
    nationality: 'United Arab Emirates',
    alpha2: 'AE',
    alpha3: 'ARE',
    iso3166: 'ISO 3166-2:AE',
    region: 'Asia',
    subRegion: 'Western Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '145',
    eeaMember: false,
    economicArea: 0,
    countryCode: '784',
    language: '',
  },
  {
    id: '583100b7-8302-4ceb-86f9-fea3abb047f7',
    identifiers: [
      'England',
      'Wales',
      'Scotland',
      'Northern Ireland',
      'Britain',
      'GB',
      'GBR',
      'UK',
      'United Kingdom',
      'United Kingdom of Great Britain and Northern Ireland',
    ],
    name: 'United Kingdom of Great Britain and Northern Ireland',
    nationality: 'British',
    alpha2: 'GB',
    alpha3: 'GBR',
    iso3166: 'ISO 3166-2:GB',
    region: 'Europe',
    subRegion: 'Northern Europe',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '150',
    subRegionCode: '154',
    eeaMember: false,
    economicArea: 0,
    countryCode: '826',
    language: 'English',
  },
  {
    id: 'c1a8cf88-4965-460e-941f-9541c1ce23fa',
    identifiers: ['United States Minor Outlying Islands', 'UM', 'UMI'],
    name: 'United States Minor Outlying Islands',
    nationality: 'United States Minor Outlying Islands',
    alpha2: 'UM',
    alpha3: 'UMI',
    iso3166: 'ISO 3166-2:UM',
    region: 'Oceania',
    subRegion: 'Micronesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '057',
    eeaMember: false,
    economicArea: 0,
    countryCode: '581',
    language: '',
  },
  {
    id: 'f5ea523f-07e3-49d9-bed1-f00eeaf88656',
    identifiers: ['United States of America', 'US', 'USA'],
    name: 'United States of America',
    nationality: 'American',
    alpha2: 'US',
    alpha3: 'USA',
    iso3166: 'ISO 3166-2:US',
    region: 'Americas',
    subRegion: 'Northern America',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '019',
    subRegionCode: '021',
    eeaMember: false,
    economicArea: 3,
    countryCode: '840',
    language: '',
  },
  {
    id: 'cd785958-6662-4fb7-a8f8-f1055aca7ded',
    identifiers: ['Uruguay', 'UY', 'URY'],
    name: 'Uruguay',
    nationality: 'Uruguayan',
    alpha2: 'UY',
    alpha3: 'URY',
    iso3166: 'ISO 3166-2:UY',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'South America',
    intermediateRegionCode: '005',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '858',
    language: '',
  },
  {
    id: '3ce6a19c-9543-4051-96d5-90342be6f9f8',
    identifiers: ['Uzbekistan', 'UZ', 'UZB'],
    name: 'Uzbekistan',
    nationality: 'Uzbekistan',
    alpha2: 'UZ',
    alpha3: 'UZB',
    iso3166: 'ISO 3166-2:UZ',
    region: 'Asia',
    subRegion: 'Central Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '143',
    eeaMember: false,
    economicArea: 0,
    countryCode: '860',
    language: '',
  },
  {
    id: '1f2ba7dd-5e50-4aa5-8c35-fc5af5dbab8a',
    identifiers: ['Vanuatu', 'VU', 'VUT'],
    name: 'Vanuatu',
    nationality: 'Vanuatu',
    alpha2: 'VU',
    alpha3: 'VUT',
    iso3166: 'ISO 3166-2:VU',
    region: 'Oceania',
    subRegion: 'Melanesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '054',
    eeaMember: false,
    economicArea: 0,
    countryCode: '548',
    language: '',
  },
  {
    id: 'ab3fef65-3d53-41a9-9676-75b484991ee3',
    identifiers: ['Venezuela (Bolivarian Republic of)', 'VE', 'VEN'],
    name: 'Venezuela (Bolivarian Republic of)',
    nationality: 'Venezuelan',
    alpha2: 'VE',
    alpha3: 'VEN',
    iso3166: 'ISO 3166-2:VE',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'South America',
    intermediateRegionCode: '005',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '862',
    language: '',
  },
  {
    id: '9264d132-94c9-41f4-a300-b4aedead6184',
    identifiers: ['Viet Nam', 'VN', 'VNM'],
    name: 'Viet Nam',
    nationality: 'Vietnamese',
    alpha2: 'VN',
    alpha3: 'VNM',
    iso3166: 'ISO 3166-2:VN',
    region: 'Asia',
    subRegion: 'South-eastern Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '035',
    eeaMember: false,
    economicArea: 0,
    countryCode: '704',
    language: '',
  },
  {
    id: 'c27f6dcd-acff-4d6c-bd23-7cf8f58c151f',
    identifiers: ['Virgin Islands (British)', 'VG', 'VGB'],
    name: 'Virgin Islands (British)',
    nationality: 'Virgin Islands',
    alpha2: 'VG',
    alpha3: 'VGB',
    iso3166: 'ISO 3166-2:VG',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '092',
    language: '',
  },
  {
    id: 'ef52e616-e737-4162-b8c0-b56acb4ae7d4',
    identifiers: ['Virgin Islands (U.S.)', 'VI', 'VIR'],
    name: 'Virgin Islands (U.S.)',
    nationality: 'Virgin Islands',
    alpha2: 'VI',
    alpha3: 'VIR',
    iso3166: 'ISO 3166-2:VI',
    region: 'Americas',
    subRegion: 'Latin America and the Caribbean',
    intermediateRegion: 'Caribbean',
    intermediateRegionCode: '029',
    regionCode: '019',
    subRegionCode: '419',
    eeaMember: false,
    economicArea: 0,
    countryCode: '850',
    language: '',
  },
  {
    id: 'f1076cd8-1007-4de5-88f9-48d6a9ecd8be',
    identifiers: ['Wallis and Futuna', 'WF', 'WLF'],
    name: 'Wallis and Futuna',
    nationality: 'Wallis and Futuna',
    alpha2: 'WF',
    alpha3: 'WLF',
    iso3166: 'ISO 3166-2:WF',
    region: 'Oceania',
    subRegion: 'Polynesia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '009',
    subRegionCode: '061',
    eeaMember: false,
    economicArea: 0,
    countryCode: '876',
    language: '',
  },
  {
    id: '069b36f0-3cab-4c49-9935-c5e2a1fd932d',
    identifiers: ['Western Sahara', 'EH', 'ESH'],
    name: 'Western Sahara',
    nationality: 'Western Sahara',
    alpha2: 'EH',
    alpha3: 'ESH',
    iso3166: 'ISO 3166-2:EH',
    region: 'Africa',
    subRegion: 'Northern Africa',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '002',
    subRegionCode: '015',
    eeaMember: false,
    economicArea: 0,
    countryCode: '732',
    language: '',
  },
  {
    id: '649de882-64b3-4e0a-8f4f-de724b4b7fc2',
    identifiers: ['Yemen', 'YE', 'YEM'],
    name: 'Yemen',
    nationality: 'Yemen',
    alpha2: 'YE',
    alpha3: 'YEM',
    iso3166: 'ISO 3166-2:YE',
    region: 'Asia',
    subRegion: 'Western Asia',
    intermediateRegion: '',
    intermediateRegionCode: '',
    regionCode: '142',
    subRegionCode: '145',
    eeaMember: false,
    economicArea: 0,
    countryCode: '887',
    language: '',
  },
  {
    id: '1b0e925b-c442-4a52-9675-81a0c8895c65',
    identifiers: ['Zambia', 'ZM', 'ZMB'],
    name: 'Zambia',
    nationality: 'Zambian',
    alpha2: 'ZM',
    alpha3: 'ZMB',
    iso3166: 'ISO 3166-2:ZM',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '894',
    language: '',
  },
  {
    id: '5f3e0071-2bfe-4229-a94c-cf3932fb2044',
    identifiers: ['Zimbabwe', 'ZW', 'ZWE'],
    name: 'Zimbabwe',
    nationality: 'Zimbabwean',
    alpha2: 'ZW',
    alpha3: 'ZWE',
    iso3166: 'ISO 3166-2:ZW',
    region: 'Africa',
    subRegion: 'Sub-Saharan Africa',
    intermediateRegion: 'Eastern Africa',
    intermediateRegionCode: '014',
    regionCode: '002',
    subRegionCode: '202',
    eeaMember: false,
    economicArea: 0,
    countryCode: '716',
    language: '',
  },
]
